var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _mask, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _mask2, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _mask3, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _rect, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3389,
    height: 2655,
    viewBox: "0 0 3389 2655",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.31 1707.84L286.81 1736.84L300.81 1770.84L374.81 1741.34L361.31 1707.84Z",
    fill: "#6CDD59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386.31 1770.84L311.81 1799.84L325.81 1833.84L399.81 1804.34L386.31 1770.84Z",
    fill: "#FF1717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.31 1877.84L356.81 1906.84L370.81 1940.84L444.81 1911.34L431.31 1877.84Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.31 1937.84L381.81 1966.84L395.81 2000.84L469.81 1971.34L456.31 1937.84Z",
    fill: "#6CDD59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M525.31 2103.84L450.81 2132.84L464.81 2166.84L538.81 2137.34L525.31 2103.84Z",
    fill: "#FF1717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.47 2323.54L1368.98 2403.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.89 2309.44L1403.18 2389.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.31 2321.84L1365.81 2404.34L1424.81 2378.34L3304.31 1612.84L3268.81 1528.84L1338.31 2321.84Z",
    fill: "#6CDD59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2545.81 1824.34L2580.31 1908.34L3304.31 1612.84L3268.81 1528.84L2545.81 1824.34Z",
    fill: "#FF1717"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M611.31 2035.84L642.31 2107.84L678.31 2198.34L2754.81 1344.34L2684.31 1182.34L611.31 2035.84Z",
    fill: "#6CDD59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.97 2295.89L1436.25 2376.09",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.92 2282.79L1468.2 2363",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1470 2269.24L1501.28 2349.45",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1504.2 2255.23L1535.7 2335.34",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1537.27 2241.68L1568.78 2321.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1572.82 2227.12L1604.33 2307.23",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.9 2213.57L1637.41 2293.68",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1640.32 2199.46L1671.83 2279.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.4 2185.91L1704.91 2266.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1706.47 2172.36L1737.98 2252.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.55 2158.81L1771.06 2238.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1773.97 2144.7L1805.48 2224.81",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.05 2131.15L1838.56 2211.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1839 2118.06L1870.28 2198.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.07 2104.51L1903.36 2184.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.27 2090.5L1937.78 2170.61",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1939.57 2076.86L1970.86 2157.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1975.12 2062.29L2006.41 2142.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2008.2 2048.74L2039.48 2128.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.4 2034.73L2073.91 2114.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2075.48 2021.18L2106.98 2101.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2112.38 2006.06L2143.66 2086.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2145.45 1992.51L2176.96 2072.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2179.88 1978.4L2211.16 2058.61",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2212.95 1964.85L2244.23 2045.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.68 1951.86L2276.18 2031.97",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2277.75 1938.3L2309.26 2018.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2312.18 1924.2L2343.69 2004.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2345.25 1910.65L2376.76 1990.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2380.8 1896.09L2412.31 1976.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.88 1882.54L2445.39 1962.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2448.3 1868.43L2479.59 1948.63",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2481.38 1854.88L2512.66 1935.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2514.45 1841.33L2545.96 1921.44",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2547.53 1827.78L2579.04 1907.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2581.95 1813.67L2613.24 1893.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2615.03 1800.12L2646.31 1880.33",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2646.75 1787.13L2678.26 1867.24",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2680.05 1773.48L2711.34 1853.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2714.25 1759.47L2745.76 1839.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2747.33 1745.92L2778.84 1826.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2782.88 1731.35L2814.39 1811.46",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2815.96 1717.8L2847.46 1797.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2850.38 1703.7L2881.89 1783.81",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2883.46 1690.14L2914.96 1770.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2913.61 1677.79L2944.89 1757.99",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2946.68 1664.24L2977.96 1744.44",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2980.88 1650.23L3012.39 1730.34",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3013.96 1636.68L3045.47 1716.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3045.91 1623.59L3077.42 1703.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-61-outside-1_900_5434",
    maskUnits: "userSpaceOnUse",
    x: 3064.67,
    y: 1581.99,
    width: 75.517,
    height: 111.022,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3064.67,
    y: 1581.99,
    width: 75.517,
    height: 111.022
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3110.49 1690.15L3078.76 1610.13C3078.76 1610.13 3075.15 1600.04 3087.53 1594.97C3099.9 1589.9 3105.85 1615.32 3105.85 1615.32"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3110.49 1690.15L3078.76 1610.13C3078.76 1610.13 3075.15 1600.04 3087.53 1594.97C3099.9 1589.9 3105.85 1615.32 3105.85 1615.32",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3078.76 1610.13L3072.17 1612.49L3072.21 1612.6L3072.25 1612.71L3078.76 1610.13ZM3117 1687.57L3085.26 1607.55L3072.25 1612.71L3103.98 1692.73L3117 1687.57ZM3078.76 1610.13C3085.35 1607.77 3085.35 1607.78 3085.35 1607.78C3085.35 1607.78 3085.35 1607.79 3085.35 1607.79C3085.36 1607.79 3085.36 1607.8 3085.36 1607.8C3085.36 1607.81 3085.37 1607.82 3085.37 1607.83C3085.38 1607.85 3085.38 1607.86 3085.38 1607.88C3085.39 1607.9 3085.4 1607.92 3085.4 1607.93C3085.41 1607.96 3085.41 1607.95 3085.4 1607.92C3085.38 1607.86 3085.35 1607.71 3085.32 1607.5C3085.26 1607.05 3085.24 1606.46 3085.36 1605.86C3085.52 1605.09 3086.05 1603.14 3090.18 1601.45L3084.87 1588.5C3076.62 1591.88 3072.78 1597.51 3071.64 1603.05C3071.12 1605.6 3071.23 1607.85 3071.46 1609.45C3071.57 1610.26 3071.72 1610.94 3071.85 1611.45C3071.92 1611.71 3071.98 1611.92 3072.04 1612.1C3072.06 1612.18 3072.09 1612.26 3072.11 1612.32C3072.12 1612.36 3072.13 1612.39 3072.14 1612.41C3072.15 1612.43 3072.15 1612.44 3072.15 1612.45C3072.16 1612.46 3072.16 1612.46 3072.16 1612.47C3072.16 1612.47 3072.16 1612.48 3072.16 1612.48C3072.16 1612.48 3072.17 1612.49 3078.76 1610.13ZM3090.18 1601.45C3090.7 1601.24 3090.85 1601.21 3091.49 1601.68C3092.52 1602.42 3093.82 1604.03 3095.14 1606.53C3096.4 1608.9 3097.39 1611.51 3098.07 1613.6C3098.4 1614.63 3098.65 1615.49 3098.81 1616.08C3098.9 1616.38 3098.95 1616.6 3098.99 1616.75C3099.01 1616.82 3099.02 1616.87 3099.03 1616.9C3099.03 1616.91 3099.03 1616.92 3099.03 1616.93C3099.03 1616.93 3099.03 1616.93 3099.03 1616.93C3099.03 1616.92 3099.03 1616.92 3099.03 1616.92C3099.03 1616.92 3099.03 1616.92 3099.03 1616.92C3099.03 1616.92 3099.03 1616.92 3105.85 1615.32C3112.66 1613.73 3112.66 1613.73 3112.66 1613.72C3112.66 1613.72 3112.66 1613.72 3112.66 1613.72C3112.66 1613.72 3112.66 1613.71 3112.66 1613.71C3112.66 1613.7 3112.66 1613.69 3112.65 1613.68C3112.65 1613.66 3112.64 1613.63 3112.63 1613.6C3112.62 1613.53 3112.59 1613.44 3112.57 1613.33C3112.51 1613.1 3112.43 1612.79 3112.32 1612.4C3112.11 1611.62 3111.8 1610.54 3111.38 1609.26C3110.56 1606.74 3109.29 1603.31 3107.51 1599.97C3105.8 1596.74 3103.29 1592.94 3099.73 1590.35C3095.77 1587.48 3090.54 1586.17 3084.87 1588.5L3090.18 1601.45Z",
    fill: "#9C9C9C",
    mask: "url(#path-61-outside-1_900_5434)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3101.71 1600.73L3133.44 1680.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M3137.48 1586.07L3168.77 1666.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M3173.03 1571.51L3204.32 1651.71",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M3206.11 1557.95L3237.62 1638.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3240.53 1543.85L3271.82 1624.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M3282.61 1526.61L3313.89 1606.81",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3353.36 1493.42L3267.63 1528.54L3302.3 1613.14L3388.02 1578.02L3353.36 1493.42Z",
    fill: "#9C9C9C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1937 1586.65L1971.5 1670.65L2702.5 1365.65L2668.5 1285.15L1937 1586.65Z",
    fill: "#FF1717"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4279 1302.08C89.8858 1295.75 97.2828 1278.08 90.9497 1262.62C84.6165 1247.17 66.9514 1239.77 51.4936 1246.1C36.0357 1252.43 28.6387 1270.1 34.9719 1285.56C41.305 1301.02 58.9701 1308.41 74.4279 1302.08Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M116.187 1404.01C131.645 1397.67 139.042 1380.01 132.709 1364.55C126.376 1349.09 108.711 1341.69 93.2528 1348.03C77.795 1354.36 70.398 1372.03 76.7311 1387.48C83.0643 1402.94 100.729 1410.34 116.187 1404.01Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M156.01 1501.2C171.468 1494.87 178.865 1477.21 172.532 1461.75C166.199 1446.29 148.534 1438.89 133.076 1445.23C117.618 1451.56 110.221 1469.22 116.554 1484.68C122.888 1500.14 140.553 1507.54 156.01 1501.2Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M227.637 1676.03C243.095 1669.7 250.492 1652.03 244.159 1636.57C237.826 1621.11 220.161 1613.72 204.703 1620.05C189.245 1626.38 181.848 1644.05 188.181 1659.51C194.514 1674.96 212.18 1682.36 227.637 1676.03Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M266.263 1770.31C281.721 1763.97 289.118 1746.31 282.785 1730.85C276.451 1715.39 258.786 1707.99 243.329 1714.33C227.871 1720.66 220.474 1738.33 226.807 1753.78C233.14 1769.24 250.805 1776.64 266.263 1770.31Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M307.654 1871.33C323.111 1865 330.508 1847.33 324.175 1831.87C317.842 1816.42 300.177 1809.02 284.719 1815.35C269.261 1821.68 261.864 1839.35 268.197 1854.81C274.531 1870.27 292.196 1877.66 307.654 1871.33Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M351.072 1977.31C366.53 1970.97 373.927 1953.31 367.594 1937.85C361.261 1922.39 343.596 1914.99 328.138 1921.33C312.68 1927.66 305.283 1945.33 311.616 1960.78C317.95 1976.24 335.615 1983.64 351.072 1977.31Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M395.229 2085.08C410.687 2078.75 418.084 2061.08 411.75 2045.63C405.417 2030.17 387.752 2022.77 372.294 2029.11C356.837 2035.44 349.439 2053.1 355.773 2068.56C362.106 2084.02 379.771 2091.42 395.229 2085.08Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M475.613 2281.28C491.071 2274.95 498.468 2257.28 492.135 2241.83C485.802 2226.37 468.137 2218.97 452.679 2225.3C437.221 2231.64 429.824 2249.3 436.157 2264.76C442.491 2280.22 460.156 2287.62 475.613 2281.28Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M518.295 2385.46C533.752 2379.13 541.15 2361.46 534.816 2346C528.483 2330.54 510.818 2323.15 495.36 2329.48C479.902 2335.81 472.505 2353.48 478.839 2368.94C485.172 2384.39 502.837 2391.79 518.295 2385.46Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M556.367 2478.39C571.825 2472.05 579.222 2454.39 572.889 2438.93C566.555 2423.47 548.89 2416.08 533.433 2422.41C517.975 2428.74 510.578 2446.41 516.911 2461.87C523.244 2477.32 540.909 2484.72 556.367 2478.39Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M648.272 2501.96C663.73 2495.63 671.127 2477.96 664.793 2462.5C658.46 2447.04 640.795 2439.65 625.337 2445.98C609.879 2452.31 602.482 2469.98 608.816 2485.44C615.149 2500.89 632.814 2508.29 648.272 2501.96Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2527.05 169.259C2542.51 162.926 2549.91 145.261 2543.57 129.803C2537.24 114.345 2519.58 106.948 2504.12 113.281C2488.66 119.614 2481.26 137.279 2487.6 152.737C2493.93 168.195 2511.59 175.592 2527.05 169.259Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2623.58 129.708C2639.04 123.375 2646.43 105.71 2640.1 90.2521C2633.77 74.7943 2616.1 67.3972 2600.64 73.7304C2585.19 80.0635 2577.79 97.7286 2584.12 113.186C2590.45 128.644 2608.12 136.041 2623.58 129.708Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M2703 97.1691C2718.46 90.836 2725.86 73.1709 2719.52 57.713C2713.19 42.2552 2695.53 34.8582 2680.07 41.1913C2664.61 47.5245 2657.21 65.1896 2663.55 80.6474C2669.88 96.1052 2687.55 103.502 2703 97.1691Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2142.52 326.802C2157.98 320.469 2165.38 302.804 2159.05 287.346C2152.71 271.888 2135.05 264.491 2119.59 270.824C2104.13 277.157 2096.73 294.822 2103.07 310.28C2109.4 325.738 2127.07 333.135 2142.52 326.802Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M2239.28 287.161C2254.73 280.828 2262.13 263.163 2255.8 247.705C2249.46 232.247 2231.8 224.85 2216.34 231.184C2200.88 237.517 2193.49 255.182 2199.82 270.64C2206.15 286.097 2223.82 293.494 2239.28 287.161Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M2318.7 254.618C2334.16 248.285 2341.56 230.62 2335.22 215.162C2328.89 199.704 2311.22 192.307 2295.77 198.641C2280.31 204.974 2272.91 222.639 2279.24 238.097C2285.58 253.554 2303.24 260.951 2318.7 254.618Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.22 451.064C1854.68 444.73 1862.08 427.065 1855.74 411.608C1849.41 396.15 1831.75 388.753 1816.29 395.086C1800.83 401.419 1793.43 419.084 1799.77 434.542C1806.1 450 1823.76 457.397 1839.22 451.064Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1935.75 411.517C1951.21 405.184 1958.6 387.519 1952.27 372.061C1945.94 356.603 1928.27 349.206 1912.81 355.539C1897.36 361.872 1889.96 379.537 1896.29 394.995C1902.62 410.453 1920.29 417.85 1935.75 411.517Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2015.17 378.978C2030.63 372.645 2038.03 354.979 2031.7 339.522C2025.36 324.064 2007.7 316.667 1992.24 323C1976.78 329.333 1969.38 346.998 1975.72 362.456C1982.05 377.914 1999.72 385.311 2015.17 378.978Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.29 610.821C1464.75 604.488 1472.15 586.823 1465.82 571.365C1459.48 555.908 1441.82 548.511 1426.36 554.844C1410.9 561.177 1403.5 578.842 1409.84 594.3C1416.17 609.758 1433.84 617.155 1449.29 610.821Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.05 571.181C1561.5 564.848 1568.9 547.183 1562.57 531.725C1556.23 516.267 1538.57 508.87 1523.11 515.203C1507.65 521.536 1500.26 539.201 1506.59 554.659C1512.92 570.117 1530.59 577.514 1546.05 571.181Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1625.47 538.638C1640.93 532.305 1648.33 514.64 1641.99 499.182C1635.66 483.724 1617.99 476.327 1602.54 482.66C1587.08 488.993 1579.68 506.658 1586.01 522.116C1592.35 537.574 1610.01 544.971 1625.47 538.638Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.42 695.169C1258.88 688.836 1266.27 671.171 1259.94 655.713C1253.61 640.255 1235.94 632.858 1220.48 639.191C1205.03 645.524 1197.63 663.19 1203.96 678.647C1210.29 694.105 1227.96 701.502 1243.42 695.169Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.57 789.751C1028.02 783.418 1035.42 765.753 1029.09 750.295C1022.75 734.837 1005.09 727.44 989.632 733.773C974.174 740.107 966.777 757.772 973.11 773.229C979.443 788.687 997.108 796.084 1012.57 789.751Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M902.091 835.013C917.548 828.68 924.945 811.015 918.612 795.557C912.279 780.099 894.614 772.702 879.156 779.035C863.698 785.368 856.301 803.033 862.634 818.491C868.968 833.949 886.633 841.346 902.091 835.013Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M819.29 868.935C834.748 862.602 842.145 844.936 835.811 829.479C829.478 814.021 811.813 806.624 796.355 812.957C780.898 819.29 773.501 836.955 779.834 852.413C786.167 867.871 803.832 875.268 819.29 868.935Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M703.189 916.501C718.647 910.168 726.044 892.503 719.711 877.045C713.378 861.587 695.713 854.19 680.255 860.523C664.797 866.857 657.4 884.522 663.733 899.979C670.066 915.437 687.731 922.834 703.189 916.501Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M620.388 950.427C635.846 944.094 643.243 926.429 636.91 910.971C630.577 895.513 612.912 888.116 597.454 894.449C581.996 900.782 574.599 918.447 580.932 933.905C587.265 949.363 604.931 956.76 620.388 950.427Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M504.963 997.716C520.42 991.383 527.817 973.718 521.484 958.26C515.151 942.802 497.486 935.405 482.028 941.738C466.57 948.071 459.173 965.736 465.507 981.194C471.84 996.652 489.505 1004.05 504.963 997.716Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M422.387 1031.55C437.845 1025.21 445.242 1007.55 438.909 992.092C432.575 976.634 414.91 969.237 399.453 975.57C383.995 981.903 376.598 999.568 382.931 1015.03C389.264 1030.48 406.929 1037.88 422.387 1031.55Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M306.511 1079.02C321.969 1072.69 329.366 1055.03 323.033 1039.57C316.7 1024.11 299.034 1016.71 283.577 1023.05C268.119 1029.38 260.722 1047.05 267.055 1062.5C273.388 1077.96 291.053 1085.36 306.511 1079.02Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M223.711 1112.95C239.168 1106.61 246.566 1088.95 240.232 1073.49C233.899 1058.03 216.234 1050.64 200.776 1056.97C185.318 1063.3 177.921 1080.97 184.255 1096.42C190.588 1111.88 208.253 1119.28 223.711 1112.95Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.835 1160.42C123.293 1154.09 130.69 1136.42 124.356 1120.97C118.023 1105.51 100.358 1098.11 84.9003 1104.45C69.4425 1110.78 62.0454 1128.44 68.3786 1143.9C74.7118 1159.36 92.3768 1166.76 107.835 1160.42Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.07 662.536C1338.53 656.203 1345.92 638.538 1339.59 623.08C1333.26 607.622 1315.59 600.225 1300.13 606.559C1284.68 612.892 1277.28 630.557 1283.61 646.015C1289.95 661.472 1307.61 668.869 1323.07 662.536Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.49 775.892L1157.25 736.253C1174.33 729.251 1182.49 709.762 1175.49 692.673L1135.85 595.922C1128.85 578.834 1109.36 570.673 1092.27 577.674L995.524 617.313C978.435 624.315 970.274 643.804 977.276 660.893L1016.91 757.643C1023.92 774.732 1043.41 782.893 1060.49 775.892Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.35 710.08C1013.92 701.323 1013.57 692.792 1013.36 683.944C1013.15 679.566 1012.84 674.962 1013.16 670.625C1013.3 665.837 1015.98 662.113 1020.8 660.402C1025.52 658.466 1030.25 656.53 1035.2 654.502C1039.7 652.658 1043.9 653.3 1047.5 656.296C1049.13 657.727 1050.64 659.476 1052.37 661.132C1060.25 669.465 1067.81 677.665 1075.69 685.998C1076.6 686.938 1077.38 688.196 1077.71 689.638C1078.32 691.756 1076.75 693.71 1075.04 694.673C1073.02 695.502 1070.85 695.34 1069.03 693.459C1065.7 689.829 1062.47 686.424 1058.92 682.887C1055.5 679.032 1051.95 675.494 1048.53 671.64C1048.43 671.415 1048.03 671.057 1047.48 671.016C1048.35 672.499 1049.13 673.757 1050.23 675.147C1055.81 683.635 1061.48 692.348 1067.06 700.835C1068.61 703.351 1068.17 704.845 1065.47 705.951C1064.57 706.32 1063.67 706.688 1062.77 707.057C1063.05 707.732 1063.24 708.182 1063.42 708.632C1067.66 718.982 1071.99 729.557 1076.23 739.907C1077.52 743.057 1077 745.635 1074.58 747.417C1071.8 749.607 1067.5 748.74 1065.89 745.457C1065.62 744.782 1065.34 744.107 1065.06 743.432C1060.92 733.307 1056.77 723.182 1052.62 713.057C1052.44 712.607 1052.16 711.932 1051.97 711.482C1051.3 711.758 1050.4 712.127 1049.5 712.496C1049.68 712.946 1049.87 713.396 1050.05 713.846C1054.29 724.196 1058.53 734.546 1062.87 745.121C1064.16 748.271 1063.73 751.074 1061.31 752.855C1058.52 755.046 1054.23 754.179 1052.62 750.896C1052.43 750.446 1052.16 749.771 1051.97 749.321C1047.83 739.196 1043.59 728.846 1039.44 718.721C1039.25 718.271 1039.07 717.821 1038.79 717.146C1037.67 717.607 1036.77 717.975 1035.64 718.436C1033.39 719.358 1031.71 718.469 1031.24 716.035C1029.79 709.274 1028.55 702.421 1027.01 695.435C1026.15 690.791 1025.08 686.239 1024.23 681.595C1024.13 681.37 1024.04 681.145 1023.95 680.92C1023.91 681.463 1023.87 682.005 1024.05 682.455C1024.4 690.986 1024.74 699.517 1025.08 708.049C1025.14 710.125 1024.57 711.936 1022.64 712.991C1020.93 713.953 1019.3 713.831 1017.62 712.942C1016.99 712.677 1016.49 712.094 1015.99 711.511C1014.81 711.205 1014.63 710.755 1014.35 710.08Z",
    fill: "#9C9C9C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.08 672.201C1116.18 672.569 1115.5 672.846 1114.6 673.215C1114.78 673.665 1114.97 674.115 1115.15 674.565C1120.87 688.515 1126.68 702.69 1132.39 716.64C1133.77 720.015 1132.9 723.002 1129.84 724.518C1127.32 726.074 1123.79 725.156 1122.14 722.415C1121.64 721.832 1121.27 720.932 1121 720.257C1110.86 695.507 1100.63 670.532 1090.49 645.781C1090.3 645.331 1090.02 644.656 1089.93 644.431C1089.52 644.074 1088.89 643.808 1088.66 643.9C1088.44 643.992 1088.17 644.627 1088.13 645.169C1088 645.486 1088.41 645.844 1088.59 646.294C1093.02 657.094 1097.22 667.986 1101.64 678.786C1103.03 682.161 1101.38 685.2 1098.18 685.724C1095.97 686.103 1093.66 684.949 1092.73 682.699C1092.37 681.799 1092 680.899 1091.63 679.999C1087.48 669.874 1083.56 659.656 1079.41 649.531C1076.64 642.781 1079.43 636.12 1086.18 633.355C1094.06 630.128 1101.93 626.902 1110.03 623.583C1116.78 620.818 1123.13 623.474 1126.12 630.132C1130.63 641.157 1135.28 651.865 1139.8 662.89C1141.18 666.265 1139.54 669.304 1136.43 670.052C1134.22 670.432 1131.91 669.277 1130.76 667.12C1129.84 664.87 1128.92 662.62 1127.99 660.37C1124.4 651.594 1120.58 642.912 1116.98 634.137C1116.89 633.912 1116.71 633.462 1116.61 633.237C1116.3 633.104 1115.66 632.838 1115.44 632.93C1115.21 633.022 1114.95 633.657 1114.81 633.974C1114.77 634.516 1115.18 634.874 1115.37 635.324C1125.6 660.299 1135.83 685.274 1146.29 710.157C1147.03 711.957 1147.45 713.625 1146.65 715.528C1145.72 717.748 1143.88 719.028 1141.35 719.275C1138.83 719.521 1137.06 718.407 1135.82 716.024C1135.63 715.574 1135.36 714.899 1135.17 714.449C1129.55 700.724 1123.83 686.774 1118.21 673.049C1117.54 673.326 1117.35 672.876 1117.08 672.201Z",
    fill: "#9C9C9C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.45 678.858C1069.81 662.658 1063.08 646.233 1056.44 630.033C1055.34 627.333 1056.04 625.205 1058.2 624.058C1060.36 622.911 1063.03 623.657 1064.17 625.815C1064.36 626.265 1064.54 626.715 1064.63 626.94C1077.91 659.34 1091.18 691.74 1104.46 724.14C1105.56 726.84 1105.09 728.876 1103.24 730.156C1101.18 731.528 1098.06 730.967 1096.91 728.809C1096.73 728.359 1096.45 727.684 1096.27 727.234C1089.63 711.034 1082.99 694.834 1076.45 678.858Z",
    fill: "#9C9C9C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.65 635.269C1023.82 633.149 1029.85 635.673 1031.97 640.848C1034.09 646.023 1031.57 652.049 1026.39 654.17C1021.22 656.29 1014.87 653.633 1012.98 648.366C1010.95 643.416 1013.47 637.39 1018.65 635.269Z",
    fill: "#9C9C9C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.68 625.634C1091.51 627.754 1085.48 625.231 1083.36 620.056C1081.24 614.881 1083.76 608.854 1088.94 606.734C1094.11 604.613 1100.14 607.137 1102.26 612.312C1104.61 617.395 1102.08 623.421 1096.68 625.634Z",
    fill: "#9C9C9C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M414.593 2231.92L417.838 2230.66L416.591 2227.41L405.005 2197.2L405 2197.19L376.759 2124.41L375.481 2121.12L372.198 2122.43L346.456 2132.71L343.248 2133.99L344.487 2137.22L372.319 2209.64L372.323 2209.65L372.328 2209.66L384.23 2240L385.505 2243.25L388.758 2241.98L414.593 2231.92Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M375.586 2208.38L401.738 2198.46",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M367.183 2180.82L393.11 2170.99",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M356.921 2157.7L382.848 2147.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M104.309 1294.2L179.696 1264.63",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M119.427 1331.1L194.814 1301.53",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M134.453 1367.77L209.84 1338.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M147.267 1399.05L222.654 1369.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M158.605 1426.73L233.992 1397.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M256.504 1665.68L331.891 1636.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M271.623 1702.57L347.009 1673",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M286.648 1739.25L362.035 1709.68",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M299.462 1770.53L374.849 1740.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M310.801 1798.2L386.187 1768.63",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M325.827 1834.88L401.214 1805.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M340.945 1871.78L416.332 1842.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M355.971 1908.45L431.358 1878.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M368.785 1939.73L444.172 1910.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M380.124 1967.41L455.51 1937.83",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M394.413 2002.28L469.799 1972.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M409.438 2038.95L484.825 2009.38",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M424.557 2075.85L499.943 2046.28",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M437.371 2107.13L512.757 2077.56",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M448.617 2134.58L524.003 2105.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M463.735 2171.48L539.121 2141.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M478.761 2208.16L554.147 2178.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M493.879 2245.05L569.265 2215.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M506.693 2276.33L582.079 2246.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M517.939 2303.78L593.326 2274.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M532.689 2339.78L608.075 2310.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M547.807 2376.68L623.194 2347.11",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M562.833 2413.36L638.219 2383.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M575.647 2444.63L651.033 2415.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M586.985 2472.31L662.372 2442.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7666 1182.79L53.5668 1170.99",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0913 1207.99L63.8915 1196.19",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3379 1235.44L75.1381 1223.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6621 1260.64L85.4623 1248.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8027 1285.39L95.6029 1273.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1274 1310.59L105.928 1298.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M88.374 1338.04L117.174 1326.24",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6987 1363.24L127.499 1351.44",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M215.957 1649.44L244.757 1637.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M226.281 1674.64L255.081 1662.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M237.528 1702.09L266.328 1690.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M247.853 1727.29L276.653 1715.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M260.389 1757.89L289.189 1746.09",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M270.714 1783.09L299.514 1771.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M282.052 1810.77L310.852 1798.97",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M292.285 1835.75L321.085 1823.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M303.347 1862.74L332.147 1850.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M313.672 1887.94L342.472 1876.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M325.01 1915.62L353.81 1903.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M335.243 1940.59L364.043 1928.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M347.78 1971.2L376.58 1959.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M358.104 1996.39L386.905 1984.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M369.443 2024.07L398.243 2012.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M379.676 2049.05L408.476 2037.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M391.383 2077.62L420.183 2065.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M401.708 2102.82L430.508 2091.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M412.955 2130.27L441.755 2118.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M423.279 2155.47L452.079 2143.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M435.816 2186.07L464.616 2174.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M446.141 2211.27L474.941 2199.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M457.387 2238.72L486.187 2226.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M467.711 2263.92L496.512 2252.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M478.774 2290.92L507.574 2279.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M489.099 2316.12L517.899 2304.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M500.345 2343.57L529.145 2331.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M510.669 2368.77L539.47 2356.97",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M523.207 2399.38L552.007 2387.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M533.532 2424.57L562.332 2412.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M544.87 2452.25L573.67 2440.45",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M555.103 2477.23L583.903 2465.43",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M109.853 1390.46L138.653 1378.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M120.085 1415.44L148.885 1403.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M131.424 1443.12L160.224 1431.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M141.749 1468.32L170.549 1456.52",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5093 1131.91L77.373 1155.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5093 1142.97L50.373 1167.04",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M121.51 1109.78L131.373 1133.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5098 1120.84L104.373 1144.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M174.16 1088.21L184.024 1112.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M147.16 1099.27L157.024 1123.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M228.161 1066.09L238.024 1090.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M201.161 1077.15L211.024 1101.22",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M283.286 1043.5L293.15 1067.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M256.286 1054.56L266.15 1078.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M337.287 1021.38L347.15 1045.45",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M310.287 1032.44L320.15 1056.51",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M389.937 999.805L399.801 1023.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M362.937 1010.87L372.801 1034.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M443.938 977.68L453.801 1001.75",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M416.938 988.742L426.801 1012.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M498.388 955.375L508.252 979.45",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M471.613 966.344L481.477 990.419",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M552.388 933.25L562.252 957.325",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M525.388 944.312L535.252 968.388",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M607.514 910.664L617.377 934.739",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M580.738 921.633L590.602 945.708",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M661.514 888.539L671.377 912.614",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M634.514 899.602L644.377 923.677",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M714.164 866.969L724.028 891.044",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M687.389 877.938L697.253 902.013",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M768.165 844.844L778.028 868.919",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M741.165 855.906L751.028 879.981",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M827.79 820.414L837.654 844.489",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M800.79 831.477L810.654 855.552",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M881.791 798.289L891.654 822.364",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M854.791 809.352L864.654 833.427",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M936.916 775.707L946.779 799.782",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M909.916 786.77L919.779 810.845",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M990.916 753.582L1000.78 777.657",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M963.916 764.645L973.78 788.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.57 732.012L1053.43 756.087",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.57 743.074L1026.43 767.149",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.57 709.887L1107.43 733.962",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.57 720.949L1080.43 745.024",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.67 666.008L1214.53 690.083",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.67 677.07L1187.53 701.145",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.67 643.883L1268.53 667.958",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.67 654.945L1241.53 679.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.79 621.297L1323.66 645.372",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.79 632.359L1296.66 656.435",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.79 599.172L1377.66 623.247",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.79 610.234L1350.66 634.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1420.44 577.602L1430.31 601.677",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.44 588.664L1403.31 612.739",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M1474.44 555.477L1484.31 579.552",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.44 566.539L1457.31 590.614",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1528.22 533.449L1538.08 557.524",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.44 544.418L1511.31 568.493",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1582.22 511.324L1592.08 535.399",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1555.22 522.387L1565.08 546.462",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1637.35 488.738L1647.21 512.813",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.35 499.801L1620.21 523.876",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.35 466.613L1701.21 490.688",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1664.35 477.676L1674.21 501.751",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1744 445.043L1753.86 469.118",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1717.22 456.012L1727.09 480.087",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1798 422.918L1807.86 446.993",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1771 433.98L1780.86 458.056",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1854.47 399.777L1864.34 423.853",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1827.47 410.84L1837.34 434.915",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.47 377.652L1918.34 401.728",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.47 388.715L1891.34 412.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1961.12 356.082L1970.99 380.157",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1934.12 367.145L1943.99 391.22",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M2015.12 333.957L2024.99 358.032",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1988.12 345.02L1997.99 369.095",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M2068.9 311.926L2078.76 336.001",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M2041.9 322.988L2051.76 347.063",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M2122.9 289.801L2132.76 313.876",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M2095.9 300.863L2105.76 324.938",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M2178.02 267.219L2187.89 291.294",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M2151.02 278.281L2160.89 302.356",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2232.02 245.094L2241.89 269.169",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M2205.02 256.156L2214.89 280.231",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M2284.68 223.523L2294.54 247.599",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M2257.68 234.586L2267.54 258.661",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M2338.68 201.398L2348.54 225.474",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M2311.68 212.461L2321.54 236.536",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M2397.63 177.246L2407.49 201.321",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M2370.63 188.309L2380.49 212.384",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M2451.4 155.215L2461.27 179.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M2424.4 166.277L2434.27 190.353",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M2504.28 133.551L2514.14 157.626",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M2477.28 144.613L2487.14 168.688",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M2558.05 111.52L2567.92 135.595",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M2531.05 122.582L2540.92 146.657",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M2612.05 89.3945L2621.92 113.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2585.05 100.457L2594.92 124.532",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M2666.05 67.2695L2675.92 91.3447",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M2639.05 78.332L2648.92 102.407",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2721.18 44.6836L2731.04 68.7588",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M2694.18 55.7461L2704.04 79.8213",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M2775.18 22.5586L2785.04 46.6338",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M2748.18 33.6211L2758.04 57.6963",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M298.309 1073.84L327.309 1144.34L2389.31 312.84L2354.81 227.84L298.309 1073.84Z",
    fill: "#6CDD59"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M185.789 1453.95L200.815 1490.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M158.789 1465.01L173.815 1501.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M239.564 1431.92L254.59 1468.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M212.564 1442.98L227.59 1479.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M242.298 1591.88L257.324 1628.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M215.298 1602.94L230.324 1639.61",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M296.073 1569.84L311.099 1606.52",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M269.073 1580.91L284.099 1617.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M601.632 2468.93L613.155 2497.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M574.632 2480L586.155 2508.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M655.408 2446.9L666.931 2475.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M628.408 2457.96L639.931 2486.09",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M196.505 1114.53L227.789 1194.73",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M229.58 1100.98L260.864 1181.18",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M264.006 1086.87L295.289 1167.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M297.081 1073.32L328.364 1153.53",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M334.432 1058.02L365.715 1138.22",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M367.507 1044.47L398.79 1124.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M401.707 1030.46L433.215 1110.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M435.007 1016.81L466.29 1097.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M468.532 1003.08L500.04 1083.19",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M501.832 989.435L533.116 1069.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M536.033 975.422L567.541 1055.53",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M569.108 961.871L600.616 1041.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M606.459 946.57L637.967 1026.68",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M639.759 932.927L671.042 1013.13",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M673.959 918.914L705.467 999.026",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M707.034 905.363L738.542 985.475",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M738.984 892.275L770.268 972.479",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M772.06 878.723L803.568 958.834",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M806.485 864.619L837.768 944.822",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M839.56 851.068L870.843 931.272",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M876.911 835.763L908.194 915.967",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M909.986 822.211L941.494 902.322",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M944.411 808.107L975.694 888.311",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M977.486 794.556L1008.77 874.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.21 781.563L1040.72 861.674",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.85 777.473L1072.67 848.584",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.92 763.922L1105.75 835.033",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.87 750.832L1137.7 821.943",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.87 736.078L1173.7 807.19",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.14 713.988L1205.65 794.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.21 700.438L1238.72 780.549",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.16 687.348L1270.67 767.459",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2788.23 168.57L2794.96 184.995",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M2779.19 177.036L2777.88 173.788L2774.64 175.092L2758.16 181.704L2754.91 183.008L2756.22 186.256L2760.84 197.765L2762.14 201.013L2765.39 199.709L2781.86 193.097L2785.11 191.793L2783.81 188.545L2779.19 177.036Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M2792.96 178.192L2780.72 182.945",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M2757.4 889.892L2763.9 906.409",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M2748.34 898.477L2747.03 895.229L2743.79 896.533L2727.31 903.145L2724.07 904.449L2725.37 907.697L2729.99 919.206L2731.29 922.454L2734.54 921.15L2751.01 914.538L2754.26 913.234L2752.96 909.986L2748.34 898.477Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2762.13 899.518L2749.98 904.496",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M3001.59 1485.92L3008 1502.22",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M2992.57 1494.35L2991.26 1491.1L2988.01 1492.4L2971.54 1499.02L2968.29 1500.32L2969.6 1503.57L2974.22 1515.08L2975.52 1518.33L2978.77 1517.02L2995.24 1510.41L2998.49 1509.11L2997.19 1505.86L2992.57 1494.35Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M3006.23 1495.32L2994.08 1500.3",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M2570.37 267.286L2564.18 250.902",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M2579.51 259.192L2580.75 262.465L2584.02 261.226L2600.62 254.942L2603.89 253.703L2602.66 250.429L2598.27 238.832L2597.03 235.559L2593.75 236.798L2577.15 243.083L2573.88 244.322L2575.12 247.595L2579.51 259.192Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M2565.73 257.887L2578.2 253.042",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M2817.88 183.225L2738.9 215.582L2754.3 253.157L2833.27 220.801L2817.88 183.225Z",
    fill: "#9C9C9C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M2814.59 232.922L2821.32 249.347",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M2805.57 241.395L2804.27 238.147L2801.02 239.451L2784.54 246.063L2781.3 247.367L2782.6 250.615L2787.22 262.124L2788.52 265.372L2791.77 264.068L2808.24 257.456L2811.49 256.152L2810.19 252.904L2805.57 241.395Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M2819.32 242.545L2807.17 247.523",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M2829.34 268.922L2836.07 285.347",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M2820.29 277.384L2818.99 274.135L2815.74 275.439L2799.26 282.052L2796.02 283.356L2797.32 286.604L2801.94 298.112L2803.24 301.36L2806.49 300.057L2822.96 293.444L2826.21 292.14L2824.91 288.892L2820.29 277.384Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2834.07 278.544L2821.83 283.297",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M2769.02 285.227L2842.41 254.633",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.72 282.901L2779.74 315.258L2792.92 347.433L2871.9 315.076L2858.72 282.901Z",
    fill: "#9C9C9C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M2784.47 904.026L2705.49 936.383L2716.28 962.708L2795.26 930.351L2784.47 904.026Z",
    fill: "#9C9C9C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M2853.03 326.746L2858.75 340.696",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M2845.85 348.976L2849.09 347.649L2847.76 344.41L2843.7 334.51L2842.38 331.271L2839.14 332.598L2822.94 339.235L2819.77 340.532L2821 343.727L2824.83 353.719L2826.11 357.063L2829.42 355.705L2845.85 348.976Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M2857.21 335.02L2844.97 339.773",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M2865.66 357.57L2871.47 371.745",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.48 379.8L2861.72 378.473L2860.39 375.234L2856.33 365.334L2855.01 362.095L2851.77 363.422L2835.57 370.06L2832.4 371.357L2833.63 374.551L2837.46 384.544L2838.74 387.887L2842.05 386.529L2858.48 379.8Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2869.84 365.845L2857.6 370.598",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M2805.8 375.005L2879.19 344.41",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2894.95 371.323L2815.97 403.68L2829.15 435.855L2908.13 403.498L2894.95 371.323Z",
    fill: "#9C9C9C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2889.26 415.172L2894.98 429.122",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2881.98 437.175L2885.22 435.848L2883.9 432.609L2879.93 422.934L2878.62 419.74L2875.41 421.004L2859.12 427.417L2855.89 428.687L2857.13 431.926L2860.96 441.919L2862.25 445.262L2865.56 443.904L2881.98 437.175Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M2893.35 423.221L2881.2 428.199",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M2901.89 445.996L2907.6 459.946",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M2894.61 467.999L2897.85 466.672L2896.52 463.433L2892.56 453.758L2891.25 450.564L2888.04 451.829L2871.75 458.241L2868.52 459.511L2869.76 462.75L2873.59 472.743L2874.87 476.086L2878.19 474.729L2894.61 467.999Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M2905.98 454.045L2893.83 459.023",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M2841.93 463.204L2915.32 432.61",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M2932.46 462.901L2853.49 495.258L2866.67 527.433L2945.65 495.076L2932.46 462.901Z",
    fill: "#9C9C9C"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M2926.69 506.52L2932.49 520.695",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M2919.5 528.749L2922.74 527.422L2921.41 524.183L2917.45 514.508L2916.14 511.314L2912.93 512.579L2896.64 518.991L2893.41 520.261L2894.65 523.5L2898.48 533.493L2899.76 536.836L2903.08 535.479L2919.5 528.749Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M2930.87 514.794L2918.62 519.547",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M2939.32 537.344L2945.12 551.519",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M2932.13 559.573L2935.37 558.246L2934.04 555.008L2930.08 545.333L2928.77 542.139L2925.56 543.403L2909.27 549.815L2906.04 551.085L2907.28 554.325L2911.11 564.317L2912.39 567.66L2915.71 566.303L2932.13 559.573Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M2943.49 545.616L2931.34 550.594",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M2968.6 551.1L2889.62 583.457L2902.62 615.182L2981.6 582.826L2968.6 551.1Z",
    fill: "#9C9C9C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M2962.73 594.496L2968.45 608.446",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M2955.45 616.501L2958.69 615.174L2957.37 611.935L2953.4 602.26L2952.08 599.021L2948.84 600.348L2932.64 606.985L2929.47 608.282L2930.7 611.475L2934.43 621.243L2935.71 624.588L2939.03 623.23L2955.45 616.501Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M2966.82 602.545L2954.67 607.523",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M2975.27 625.098L2980.98 639.048",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M2967.99 647.101L2971.23 645.774L2969.9 642.535L2965.94 632.86L2964.63 629.666L2961.42 630.93L2945.13 637.342L2941.9 638.613L2943.14 641.852L2946.97 651.844L2948.25 655.188L2951.57 653.83L2967.99 647.101Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M2979.35 633.147L2967.2 638.125",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M2779.28 947.145L2784.99 961.095",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M2772 969.149L2775.24 967.822L2773.91 964.584L2769.95 954.909L2768.62 951.67L2765.38 952.997L2749.18 959.634L2746.02 960.93L2747.24 964.124L2750.98 973.891L2752.26 977.237L2755.57 975.879L2772 969.149Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M2783.59 955.102L2771.21 960.172",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M2791.81 977.746L2797.53 991.696",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M2784.54 999.749L2787.78 998.422L2786.45 995.184L2782.48 985.508L2781.18 982.314L2777.96 983.579L2761.67 989.991L2758.44 991.261L2759.69 994.501L2763.52 1004.49L2764.8 1007.84L2768.11 1006.48L2784.54 999.749Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M2796.12 985.703L2783.75 990.773",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M2821.44 994.253L2742.46 1026.61L2753.25 1052.93L2832.22 1020.58L2821.44 994.253Z",
    fill: "#9C9C9C"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M2816.33 1037.59L2821.96 1051.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M2809.01 1059.61L2812.31 1058.31L2810.97 1055.03L2807.01 1045.36L2805.7 1042.16L2802.48 1043.43L2786.19 1049.84L2782.97 1051.11L2784.21 1054.35L2787.94 1064.11L2789.21 1067.41L2792.5 1066.12L2809.01 1059.61Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M2820.65 1045.55L2808.18 1050.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M2828.78 1067.97L2834.49 1081.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M2821.5 1089.97L2824.74 1088.65L2823.41 1085.41L2819.45 1075.73L2818.12 1072.49L2814.88 1073.82L2798.68 1080.46L2795.52 1081.75L2796.74 1084.95L2800.48 1094.72L2801.76 1098.06L2805.08 1096.7L2821.5 1089.97Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M2833.09 1075.93L2820.71 1081",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.31 1084.25L2779.33 1116.61L2790.12 1142.93L2869.1 1110.58L2858.31 1084.25Z",
    fill: "#9C9C9C"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M2853.12 1127.37L2858.83 1141.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M2845.84 1149.38L2849.08 1148.05L2847.75 1144.81L2843.79 1135.14L2842.46 1131.9L2839.22 1133.22L2823.02 1139.86L2819.86 1141.16L2821.08 1144.35L2824.82 1154.12L2826.1 1157.46L2829.41 1156.11L2845.84 1149.38Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M2857.43 1135.33L2845.05 1140.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M2865.65 1157.97L2871.37 1171.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.38 1179.98L2861.61 1178.65L2860.29 1175.41L2856.32 1165.74L2855.02 1162.54L2851.8 1163.81L2835.51 1170.22L2832.28 1171.49L2833.52 1174.73L2837.36 1184.72L2838.64 1188.06L2841.95 1186.71L2858.38 1179.98Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M2869.96 1165.93L2857.59 1171",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M2894.45 1172.45L2815.47 1204.81L2826.26 1231.13L2905.23 1198.78L2894.45 1172.45Z",
    fill: "#9C9C9C"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M2889.25 1215.57L2894.97 1229.52",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M2882.02 1237.82L2885.32 1236.52L2883.98 1233.23L2879.92 1223.33L2878.6 1220.1L2875.36 1221.42L2859.16 1228.06L2855.99 1229.36L2857.22 1232.55L2860.95 1242.32L2862.22 1245.62L2865.51 1244.32L2882.02 1237.82Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M2893.56 1223.53L2881.19 1228.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M2901.79 1246.17L2907.5 1260.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M2894.51 1268.18L2897.75 1266.85L2896.42 1263.61L2892.46 1253.94L2891.13 1250.7L2887.89 1252.02L2871.69 1258.66L2868.53 1259.96L2869.75 1263.15L2873.49 1272.92L2874.77 1276.26L2878.09 1274.91L2894.51 1268.18Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M2906.1 1254.13L2893.72 1259.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M2930.4 1260.2L2851.42 1292.56L2862.21 1318.88L2941.18 1286.53L2930.4 1260.2Z",
    fill: "#9C9C9C"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M2925.2 1303.32L2930.92 1317.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M2917.93 1325.33L2921.17 1324L2919.84 1320.76L2915.88 1311.09L2914.55 1307.85L2911.31 1309.18L2895.11 1315.81L2891.95 1317.11L2893.17 1320.3L2896.91 1330.07L2898.19 1333.42L2901.5 1332.06L2917.93 1325.33Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M2929.51 1311.28L2917.14 1316.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M2937.74 1333.93L2943.36 1347.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M2930.46 1355.93L2933.7 1354.6L2932.38 1351.36L2928.41 1341.69L2927.1 1338.49L2923.89 1339.76L2907.6 1346.17L2904.37 1347.44L2905.61 1350.68L2909.44 1360.67L2910.73 1364.02L2914.04 1362.66L2930.46 1355.93Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M2942.05 1341.88L2929.58 1346.73",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M2967.09 1349.75L2888.11 1382.11L2898.9 1408.43L2977.87 1376.08L2967.09 1349.75Z",
    fill: "#9C9C9C"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M3003.32 1438.18L2924.34 1470.54L2938.35 1504.74L3017.33 1472.38L3003.32 1438.18Z",
    fill: "#9C9C9C"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M2961.89 1392.88L2967.52 1406.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M2954.62 1414.88L2957.86 1413.55L2956.53 1410.31L2952.56 1400.64L2951.26 1397.44L2948.04 1398.71L2931.75 1405.12L2928.52 1406.39L2929.77 1409.63L2933.6 1419.62L2934.88 1422.96L2938.19 1421.61L2954.62 1414.88Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M2966.2 1400.83L2953.74 1405.68",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M2974.34 1423.25L2980.05 1437.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M2967.11 1445.5L2970.41 1444.2L2969.07 1440.91L2965.1 1431.24L2963.79 1428.05L2960.58 1429.31L2944.29 1435.72L2941.06 1436.99L2942.3 1440.23L2946.04 1450L2947.3 1453.3L2950.59 1452L2967.11 1445.5Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M2978.74 1431.43L2966.27 1436.28",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M2823.1 862.977L2829.83 879.402",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.19 853.345L2856.84 850.116L2853.61 851.466L2837.23 858.313L2834 859.663L2835.35 862.892L2840.13 874.333L2841.48 877.563L2844.71 876.213L2861.09 869.366L2864.32 868.016L2862.97 864.787L2858.19 853.345Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M2826.25 873.242L2838.63 868.172",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M3067.29 1459L3073.93 1475.2",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M3102.41 1449.21L3101.06 1445.98L3097.83 1447.33L3081.46 1454.18L3078.23 1455.53L3079.58 1458.76L3084.36 1470.2L3085.71 1473.43L3088.94 1472.08L3105.32 1465.23L3108.55 1463.88L3107.2 1460.65L3102.41 1449.21Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M3070.36 1469.05L3082.73 1463.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M2824.29 918.439L2903.26 886.082L2892.48 859.757L2813.5 892.114L2824.29 918.439Z",
    fill: "#9C9C9C"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M2847.45 919.211L2853.39 933.069",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M2863.77 927.856L2865.14 930.989L2868.3 929.693L2884.5 923.055L2887.74 921.729L2886.41 918.49L2882.45 908.815L2881.12 905.576L2877.88 906.903L2861.46 913.632L2858.14 914.991L2859.58 918.273L2863.77 927.856Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M2850.19 927.812L2862.34 922.835",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M2859.99 949.812L2865.93 963.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M2876.3 958.456L2877.67 961.589L2880.84 960.293L2897.04 953.655L2900.28 952.329L2898.95 949.09L2894.89 939.19L2893.55 935.906L2890.28 937.296L2873.95 944.251L2870.7 945.635L2872.11 948.873L2876.3 958.456Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M2862.72 958.414L2874.87 953.436",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M2861.32 1008.84L2940.3 976.484L2929.51 950.159L2850.54 982.516L2861.32 1008.84Z",
    fill: "#9C9C9C"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M2884.51 1009.66L2890.36 1023.3",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M2900.82 1018.31L2902.21 1021.48L2905.4 1020.13L2921.51 1013.26L2924.69 1011.91L2923.38 1008.72L2919.41 999.041L2918.07 995.758L2914.8 997.148L2898.47 1004.1L2895.22 1005.49L2896.64 1008.72L2900.82 1018.31Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M2887.25 1018.27L2899.3 1013.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M2896.95 1040.04L2902.89 1053.9",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M2913.27 1048.68L2914.64 1051.82L2917.8 1050.52L2934 1043.88L2937.24 1042.56L2935.91 1039.32L2931.95 1029.64L2930.62 1026.4L2927.39 1027.73L2910.96 1034.46L2907.65 1035.82L2909.08 1039.1L2913.27 1048.68Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M2899.69 1048.64L2911.84 1043.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M2898.12 1098.65L2977.1 1066.29L2966.31 1039.97L2887.33 1072.32L2898.12 1098.65Z",
    fill: "#9C9C9C"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M2921.29 1099.44L2927.23 1113.3",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M2937.61 1108.08L2938.98 1111.22L2942.14 1109.92L2958.34 1103.28L2961.58 1101.96L2960.25 1098.72L2956.29 1089.04L2954.96 1085.8L2951.72 1087.13L2935.3 1093.86L2931.98 1095.22L2933.42 1098.5L2937.61 1108.08Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M2924.03 1108.04L2936.18 1103.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M2933.83 1130.04L2939.77 1143.9",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M2950.14 1138.68L2951.51 1141.82L2954.68 1140.52L2970.88 1133.88L2974.12 1132.56L2972.79 1129.32L2968.73 1119.42L2967.39 1116.13L2964.12 1117.52L2947.79 1124.48L2944.54 1125.86L2945.95 1129.1L2950.14 1138.68Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M2936.56 1138.64L2948.71 1133.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M2934.31 1186.99L3013.29 1154.63L3002.5 1128.31L2923.53 1160.66L2934.31 1186.99Z",
    fill: "#9C9C9C"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M2957.43 1187.64L2963.37 1201.5",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M2973.83 1196.51L2975.22 1199.69L2978.41 1198.33L2994.52 1191.47L2997.7 1190.11L2996.39 1186.92L2992.42 1177.24L2991.1 1174.01L2987.86 1175.33L2971.43 1182.06L2968.12 1183.42L2969.55 1186.7L2973.83 1196.51Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M2960.16 1196.24L2972.31 1191.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M2969.96 1218.24L2975.91 1232.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M2986.28 1226.89L2987.65 1230.02L2990.81 1228.72L3007.01 1222.09L3010.25 1220.76L3008.93 1217.52L3004.96 1207.85L3003.63 1204.61L3000.4 1205.93L2983.97 1212.66L2980.66 1214.02L2982.09 1217.3L2986.28 1226.89Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M2972.7 1226.84L2984.85 1221.87",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M2970.19 1274.56L3049.16 1242.2L3038.38 1215.87L2959.4 1248.23L2970.19 1274.56Z",
    fill: "#9C9C9C"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M2993.38 1275.39L2999.32 1289.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M3009.69 1284.04L3011.06 1287.17L3014.23 1285.87L3030.43 1279.24L3033.67 1277.91L3032.34 1274.67L3028.38 1264.99L3027.05 1261.76L3023.81 1263.08L3007.38 1269.81L3004.07 1271.17L3005.5 1274.45L3009.69 1284.04Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M2996.12 1283.99L3008.27 1279.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M3005.92 1305.99L3011.76 1319.63",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M3022.23 1314.64L3023.6 1317.77L3026.76 1316.47L3042.96 1309.84L3046.2 1308.51L3044.88 1305.27L3040.82 1295.37L3039.48 1292.09L3036.21 1293.48L3019.88 1300.43L3016.63 1301.81L3018.04 1305.05L3022.23 1314.64Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M3008.65 1314.6L3020.71 1309.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M3006.83 1364L3085.81 1331.64L3075.02 1305.32L2996.05 1337.67L3006.83 1364Z",
    fill: "#9C9C9C"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M3046.3 1460.33L3125.28 1427.98L3111.27 1393.78L3032.29 1426.13L3046.3 1460.33Z",
    fill: "#9C9C9C"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M3030.07 1364.94L3035.92 1378.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M3046.38 1373.58L3047.75 1376.72L3050.92 1375.42L3067.12 1368.78L3070.36 1367.46L3069.03 1364.22L3064.97 1354.32L3063.63 1351.04L3060.36 1352.43L3044.03 1359.38L3040.78 1360.76L3042.19 1364L3046.38 1373.58Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M3032.8 1373.55L3044.86 1368.34",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M3042.51 1395.32L3048.45 1409.17",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M3058.92 1404.19L3060.31 1407.36L3063.5 1406L3079.61 1399.14L3082.78 1397.79L3081.47 1394.6L3077.51 1384.92L3076.16 1381.64L3072.9 1383.03L3056.57 1389.98L3053.32 1391.37L3054.73 1394.6L3058.92 1404.19Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M3045.34 1404.14L3057.4 1398.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M2915.4 642.528L2988.8 611.934",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M3005.29 640.651L2926.31 673.008L2941.43 709.908L3020.41 677.551L3005.29 640.651Z",
    fill: "#9C9C9C"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M3001.73 689.676L3008.27 705.651",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M2974.35 718.206L2975.66 721.454L2978.91 720.151L2995.38 713.54L2998.63 712.237L2997.32 708.988L2992.8 697.705L2991.49 694.457L2988.24 695.76L2971.77 702.371L2968.52 703.674L2969.83 706.922L2974.35 718.206Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M3006.36 699.071L2994.12 703.824",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M3016.2 725L3022.74 740.975",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M2988.79 753.624L2990.09 756.872L2993.34 755.569L3009.81 748.958L3013.06 747.655L3011.76 744.406L3007.23 733.123L3005.93 729.875L3002.68 731.178L2986.2 737.789L2982.96 739.092L2984.26 742.34L2988.79 753.624Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M3020.84 734.397L3008.69 739.375",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M2955.87 741.305L3029.26 710.711",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M3045.48 738.753L2966.51 771.109L2979.6 803.06L3058.57 770.703L3045.48 738.753Z",
    fill: "#9C9C9C"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M3039.71 782.375L3045.42 796.325",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M3032.43 804.378L3035.67 803.051L3034.34 799.812L3030.38 790.137L3029.07 786.943L3025.86 788.207L3009.56 794.62L3006.34 795.89L3007.58 799.129L3011.41 809.122L3012.69 812.465L3016 811.108L3032.43 804.378Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M3043.79 790.424L3031.64 795.402",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M3052.24 812.977L3057.96 826.927",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M3045.01 835.224L3048.32 833.924L3046.97 830.641L3042.91 820.74L3041.59 817.502L3038.35 818.829L3022.15 825.466L3018.98 826.762L3020.21 829.956L3023.95 839.723L3025.21 843.023L3028.5 841.729L3045.01 835.224Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M3056.42 821.251L3044.18 826.004",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M2992.38 830.407L3065.77 799.813",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M3082.08 828.077L3003.1 860.434L3016.19 892.384L3095.17 860.027L3082.08 828.077Z",
    fill: "#9C9C9C"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M3076.3 871.699L3082.11 885.874",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M3069.12 893.929L3072.36 892.602L3071.03 889.363L3067.07 879.688L3065.76 876.494L3062.55 877.758L3046.25 884.17L3043.03 885.441L3044.27 888.68L3048.1 898.673L3049.38 902.016L3052.69 900.658L3069.12 893.929Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M3080.48 879.974L3068.24 884.727",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M3088.93 902.523L3094.65 916.474",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M3081.7 924.771L3085 923.471L3083.66 920.187L3079.6 910.287L3078.28 907.049L3075.04 908.376L3058.84 915.013L3055.67 916.309L3056.9 919.503L3060.63 929.27L3061.9 932.57L3065.19 931.275L3081.7 924.771Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M3093.02 910.573L3080.87 915.551",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M3029.07 919.958L3102.46 889.363",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M3118.77 917.628L3039.79 949.984L3051.96 979.685L3130.94 947.328L3118.77 917.628Z",
    fill: "#9C9C9C"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M3111.98 958.773L3117.32 971.824",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M3104.33 979.877L3107.57 978.55L3106.24 975.311L3102.56 966.311L3101.23 963.072L3097.99 964.399L3081.79 971.036L3078.63 972.33L3079.85 975.52L3083.31 984.613L3084.59 987.967L3087.91 986.606L3104.33 979.877Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M3115.88 966.372L3103.64 971.125",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M3123.68 987.348L3128.94 1000.17",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M3116.04 1008.45L3119.28 1007.13L3117.95 1003.89L3114.26 994.887L3112.96 991.693L3109.74 992.957L3093.45 999.37L3090.23 1000.64L3091.46 1003.87L3095.02 1013.19L3096.3 1016.54L3099.61 1015.18L3116.04 1008.45Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M3127.49 994.721L3115.34 999.699",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M3063.91 1005.01L3137.4 974.637",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M3153.89 1003.35L3074.92 1035.71L3088.37 1068.56L3167.35 1036.2L3153.89 1003.35Z",
    fill: "#9C9C9C"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M3148.57 1048.1L3154.47 1062.5",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M3141.53 1070.8L3144.83 1069.5L3143.49 1066.22L3139.34 1056.09L3138.03 1052.9L3134.82 1054.16L3118.53 1060.57L3115.3 1061.84L3116.54 1065.08L3120.46 1075.3L3121.73 1078.6L3125.01 1077.3L3141.53 1070.8Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M3152.84 1056.6L3140.6 1061.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M3161.57 1079.83L3167.47 1094.23",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M3154.48 1102.28L3157.72 1100.96L3156.39 1097.72L3152.24 1087.59L3150.92 1084.35L3147.68 1085.68L3131.48 1092.32L3128.31 1093.62L3129.54 1096.81L3133.46 1107.03L3134.74 1110.37L3138.06 1109.01L3154.48 1102.28Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M3165.75 1088.1L3153.6 1093.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M3101.62 1097.03L3175.01 1066.44",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M3190.12 1091.78L3111.14 1124.14L3127.09 1163.06L3206.07 1130.71L3190.12 1091.78Z",
    fill: "#9C9C9C"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M3187.38 1142.82L3194.39 1159.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M3160.48 1172.5L3161.79 1175.74L3165.04 1174.44L3181.51 1167.82L3184.76 1166.52L3183.45 1163.27L3178.65 1151.31L3177.34 1148.06L3174.09 1149.37L3157.62 1155.98L3154.38 1157.29L3155.68 1160.54L3160.48 1172.5Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M3192.3 1152.9L3180.06 1157.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M3202.69 1180.18L3209.6 1197.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M3175.61 1209.83L3176.91 1213.08L3180.16 1211.78L3196.63 1205.16L3199.88 1203.85L3198.57 1200.61L3193.77 1188.65L3192.47 1185.4L3189.22 1186.7L3172.75 1193.32L3169.5 1194.63L3170.8 1197.87L3175.61 1209.83Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M3207.51 1190.03L3195.36 1195",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M3142.27 1196.26L3215.66 1165.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M3232.98 1196.41L3154.01 1228.76L3166.82 1260.04L3245.8 1227.68L3232.98 1196.41Z",
    fill: "#9C9C9C"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M3226.93 1239.35L3232.46 1252.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M3219.52 1261.15L3222.82 1259.85L3221.47 1256.56L3217.51 1246.89L3216.18 1243.65L3212.94 1244.98L3196.74 1251.61L3193.58 1252.91L3194.8 1256.1L3198.45 1265.64L3199.71 1268.95L3203 1267.65L3219.52 1261.15Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M3230.93 1247.17L3218.77 1252.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M3239.19 1269.28L3244.81 1283",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M3231.82 1291.06L3235.06 1289.73L3233.73 1286.49L3229.86 1277.04L3228.55 1273.85L3225.34 1275.11L3209.05 1281.52L3205.82 1282.79L3207.06 1286.03L3210.8 1295.8L3212.08 1299.14L3215.4 1297.78L3231.82 1291.06Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M3243.28 1277.33L3231.04 1282.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M3298.74 1414.63L3304.37 1428.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M3291.37 1436.41L3294.61 1435.08L3293.29 1431.84L3289.41 1422.39L3288.09 1419.15L3284.85 1420.48L3268.65 1427.12L3265.49 1428.41L3266.71 1431.61L3270.35 1441.15L3271.63 1444.5L3274.95 1443.14L3291.37 1436.41Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M3302.83 1422.68L3290.59 1427.43",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M3179.33 1286.71L3252.81 1256.34",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M3268.38 1282.81L3189.41 1315.16L3202.22 1346.44L3281.2 1314.08L3268.38 1282.81Z",
    fill: "#9C9C9C"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M3304.52 1371.01L3225.54 1403.36L3238.36 1434.64L3317.33 1402.28L3304.52 1371.01Z",
    fill: "#9C9C9C"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M3262.24 1325.53L3267.86 1339.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M3254.92 1347.55L3258.22 1346.25L3256.87 1342.97L3252.91 1333.29L3251.58 1330.05L3248.34 1331.38L3232.14 1338.02L3228.98 1339.31L3230.2 1342.5L3233.85 1352.05L3235.11 1355.35L3238.4 1354.05L3254.92 1347.55Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M3266.32 1333.58L3254.17 1338.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M3274.59 1355.68L3280.21 1369.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M3267.22 1377.45L3270.46 1376.13L3269.13 1372.89L3265.26 1363.44L3263.95 1360.24L3260.74 1361.51L3244.45 1367.92L3241.22 1369.19L3242.46 1372.43L3246.2 1382.2L3247.48 1385.54L3250.8 1384.18L3267.22 1377.45Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M3278.58 1363.5L3266.43 1368.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M3214.73 1373.11L3288.21 1342.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M3250.86 1461.31L3324.35 1430.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M3263.95 1493.26L3337.34 1462.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.18 754.458L1273.88 670.758",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.03 741.001L1306.73 657.301",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.88 727.54L1339.58 643.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.18 713.896L1372.88 630.195",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.2 698.318L1410.91 614.617",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.83 684.951L1443.53 601.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.68 671.494L1476.38 587.793",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.2 657.755L1509.91 574.055",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M1582 642.271L1547.71 558.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.85 628.814L1580.56 545.113",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.48 615.447L1613.19 531.746",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M1681 601.708L1646.71 518.008",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M1718.8 586.224L1684.51 502.523",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M1751.65 572.767L1717.36 489.066",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M1784.5 559.306L1750.21 475.605",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M1817.8 545.662L1783.51 461.961",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M1850.88 532.111L1816.59 448.41",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M1883.73 518.654L1849.44 434.953",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.58 505.193L1882.29 421.492",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M1949.88 491.548L1915.59 407.848",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1987.91 475.97L1953.61 392.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M2020.53 462.603L1986.24 378.902",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M2053.38 449.146L2019.09 365.445",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M2086.68 435.501L2052.39 351.801",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M2124.71 419.923L2090.41 336.223",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M2157.56 406.466L2123.26 322.766",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M2190.18 393.099L2155.89 309.398",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M2223.71 379.361L2189.41 295.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M2257.01 365.716L2222.72 282.016",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M2289.86 352.259L2255.57 268.559",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M2322.71 338.798L2288.42 255.098",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M2356.01 325.154L2321.72 241.453",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M2391.56 310.591L2357.27 226.891",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2318 1172.11L1032.03 774.42L1035.51 773.001L1033.85 769.629L1018.41 738.376L1016.97 735.445L1013.94 736.689L8.60696 1150.42L5.38631 1151.74L6.69576 1154.97L141.677 1487.64C141.693 1487.68 141.711 1487.74 141.732 1487.8C141.797 1487.99 141.89 1488.24 142.015 1488.55C142.264 1489.17 142.642 1490.01 143.183 1490.99C144.26 1492.95 146.005 1495.49 148.689 1497.88C154.186 1502.77 163.184 1506.61 177.186 1504.26L177.51 1504.21L177.817 1504.09L241.289 1480.72L241.639 1480.59L241.953 1480.39L240.08 1477.43C241.953 1480.39 241.954 1480.39 241.955 1480.39L241.958 1480.39L241.965 1480.38L241.985 1480.37L242.043 1480.33C242.091 1480.3 242.156 1480.26 242.237 1480.2C242.4 1480.09 242.627 1479.94 242.909 1479.74C243.472 1479.34 244.256 1478.76 245.179 1478C247.018 1476.5 249.443 1474.28 251.772 1471.44C256.399 1465.79 260.94 1457.27 259.079 1446.8L256.26 1430.94L255.975 1429.33L257.158 1423.56L251.085 1426.05L173.323 1457.91L56.2318 1172.11Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-583-outside-2_900_5434",
    maskUnits: "userSpaceOnUse",
    x: 1154.95,
    y: -2.5912,
    width: 1667.55,
    height: 720.933,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1154.95,
    y: -2.5912,
    width: 1667.55,
    height: 720.933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.05 709.149L2811.25 37.4754L2795.57 9.47508L1159.65 681.823"
  }))), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M2811.25 37.4754L2813.9 43.951L2821.21 40.9503L2817.35 34.0558L2811.25 37.4754ZM2795.57 9.47508L2801.68 6.05552L2798.65 0.642218L2792.91 3.00056L2795.57 9.47508ZM1177.7 715.624L2813.9 43.951L2808.59 30.9997L1172.39 702.673L1177.7 715.624ZM2817.35 34.0558L2801.68 6.05552L2789.46 12.8946L2805.14 40.8949L2817.35 34.0558ZM2792.91 3.00056L1156.98 675.349L1162.31 688.298L2798.23 15.9496L2792.91 3.00056Z",
    fill: "#9C9C9C",
    mask: "url(#path-583-outside-2_900_5434)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M131.417 1139.1L53.5669 1170.99L94.4045 1270.67L172.255 1238.77L131.417 1139.1Z",
    fill: "#9C9C9C"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M164.677 1125.99L124.177 1142.59L156.533 1221.56L197.034 1204.97L164.677 1125.99Z",
    fill: "#9C9C9C"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M2387.39 227.949L2371.19 234.586",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M2397.24 262.994L2400.48 261.661L2399.14 258.425L2392.38 242.012L2391.05 238.776L2387.81 240.109L2376.35 244.831L2373.11 246.164L2374.44 249.4L2381.2 265.813L2382.54 269.049L2385.77 267.716L2397.24 262.994Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M2377.35 231.016L2382.42 243.391",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M2409.06 205.146L2387.01 214.18L2418.17 290.23L2440.22 281.196L2409.06 205.146Z",
    fill: "#9C9C9C"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M2595.71 127.098L2404.23 205.547L2440.37 293.747L2631.84 215.299L2595.71 127.098Z",
    fill: "#9C9C9C"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M2688.41 89.1178L2595.71 127.098L2617.28 179.748L2709.98 141.768L2688.41 89.1178Z",
    fill: "#9C9C9C"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M2770.63 57.0082L2686.93 91.3008L2724.73 183.551L2808.43 149.259L2770.63 57.0082Z",
    fill: "#9C9C9C"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M2517.22 288.276L2510.04 272.035",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M2482.12 298.96L2483.54 302.162L2486.74 300.749L2502.97 293.579L2506.18 292.166L2504.76 288.964L2499.75 277.62L2498.34 274.419L2495.14 275.832L2478.9 283.001L2475.7 284.415L2477.11 287.617L2482.12 298.96Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M2513.61 278.194L2501.65 283.622",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M2681.78 627.727L2692.58 623.302C2697.9 621.124 2700.8 614.905 2698.48 609.221L2552 251.694C2549.82 246.376 2543.6 243.469 2537.91 245.797L2527.11 250.222C2521.8 252.401 2518.89 258.62 2521.22 264.304L2667.7 621.831C2669.88 627.149 2676.1 630.056 2681.78 627.727Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M3043.56 1511.4L3055.49 1506.51C3061.1 1504.21 3063.68 1498.04 3061.38 1492.43L2746.3 723.373C2744.12 718.055 2737.9 715.149 2732.22 717.477L2720.29 722.363C2714.97 724.542 2712.07 730.761 2714.39 736.444L3029.48 1505.5C3031.66 1510.82 3037.88 1513.72 3043.56 1511.4Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M2455.18 321.574L2638.33 246.536",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M2468.92 355.098L2652.07 280.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M2483.39 390.426L2666.54 315.388",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M2497.77 425.527L2680.92 350.489",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M2511.51 459.051L2694.66 384.013",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M2525.89 494.152L2709.04 419.114",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M2538.98 526.102L2722.13 451.064",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M2552.71 559.625L2735.86 484.587",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M2567.09 594.727L2750.24 519.689",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.46 627.352L2763.61 552.314",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M2639.18 770.676L2822.33 695.638",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M2652.92 804.199L2836.07 729.161",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M2667.3 839.301L2850.45 764.263",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M2680.66 871.926L2863.82 796.888",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M2694.86 906.578L2878.01 831.54",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M2664.41 671.265L2680.23 624.579",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M2674.65 703.328L2727.24 723.299",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M2724.09 995.242L2913.33 919.025",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M2761.24 1085.92L2950.48 1009.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M2797.38 1174.12L2986.71 1098.13",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M2832.59 1260.07L3021.83 1183.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M2870.2 1351.87L3059.53 1275.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M2906.43 1440.3L3095.67 1364.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M2949.76 1546.05L3139.09 1470.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M2797.05 918.055L2815.27 910.588",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M2830.7 1000.18L2848.92 992.713",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M2862.32 1077.36L2880.54 1069.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M2898.09 1165.96L2916.32 1158.5",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M2914.6 1206.24L2932.82 1198.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M2933.22 1251.69L2951.44 1244.22",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M2949.81 1292.19L2968.04 1284.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M2969.91 1341.24L2988.13 1333.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M2985.49 1379.27L3003.71 1371.8",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M3006.87 1431.47L3025.1 1424",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M298.31 1265.84L329.31 1337.84L365.31 1428.34L2441.81 574.34L2371.31 412.34L298.31 1265.84Z",
    fill: "#6CDD59"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M407.31 1533.84L438.31 1605.84L474.31 1696.34L2550.81 842.34L2480.31 680.34L407.31 1533.84Z",
    fill: "#6CDD59"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M509.31 1784.84L540.31 1856.84L576.31 1947.34L2652.81 1093.34L2582.31 931.34L509.31 1784.84Z",
    fill: "#6CDD59"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M713.31 2286.84L744.31 2358.84L780.31 2449.34L2856.81 1595.34L2786.31 1433.34L713.31 2286.84Z",
    fill: "#6CDD59"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M3022.64 1469.94L3040.86 1462.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M3007.38 1606.53L3049.32 1508.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M218.248 1600.82L217.862 1600.99C217.86 1600.99 217.858 1600.99 217.856 1600.99C217.625 1601.05 217.322 1601.15 216.965 1601.28C216.251 1601.55 215.309 1601.98 214.27 1602.65C212.167 1604.01 209.735 1606.32 208.022 1610.14C204.622 1617.72 204.379 1630.42 213.179 1651.89L213.284 1652.15L213.396 1652.42L213.516 1652.72L213.643 1653.03L213.777 1653.35L213.918 1653.7L214.067 1654.06L214.222 1654.44L214.385 1654.84L214.555 1655.25L214.731 1655.68L214.915 1656.13L215.106 1656.6L215.303 1657.08L215.508 1657.58L215.719 1658.09L215.937 1658.63L216.162 1659.18L216.394 1659.74L216.633 1660.32L216.878 1660.92L217.13 1661.54L217.388 1662.17L217.654 1662.82L217.926 1663.48L218.204 1664.16L218.489 1664.85L218.78 1665.57L219.078 1666.29L219.383 1667.04L219.694 1667.8L220.011 1668.57L220.335 1669.36L220.665 1670.17L221.001 1670.99L221.344 1671.82L221.693 1672.67L222.048 1673.54L222.409 1674.42L222.776 1675.32L223.15 1676.23L223.53 1677.16L223.915 1678.1L224.307 1679.06L224.705 1680.03L225.109 1681.01L225.519 1682.01L225.934 1683.03L226.356 1684.06L226.783 1685.1L227.217 1686.16L227.656 1687.23L228.101 1688.32L228.552 1689.42L229.008 1690.53L229.47 1691.66L229.938 1692.8L230.411 1693.96L230.89 1695.12L231.375 1696.31L231.865 1697.5L232.361 1698.71L232.862 1699.94L233.369 1701.17L233.881 1702.42L234.398 1703.69L234.921 1704.96L235.449 1706.25L235.983 1707.55L236.522 1708.87L237.066 1710.2L237.615 1711.54L238.17 1712.89L238.729 1714.26L239.294 1715.64L239.864 1717.03L240.439 1718.43L241.019 1719.85L241.604 1721.27L242.194 1722.71L242.789 1724.17L243.389 1725.63L243.994 1727.11L244.604 1728.6L245.218 1730.1L245.838 1731.61L246.462 1733.13L247.091 1734.67L247.725 1736.21L248.363 1737.77L249.006 1739.34L249.654 1740.92L250.306 1742.51L250.963 1744.12L251.624 1745.73L252.29 1747.36L252.961 1748.99L253.636 1750.64L254.315 1752.3L254.999 1753.97L255.687 1755.65L256.38 1757.34L257.076 1759.04L257.778 1760.75L258.483 1762.47L259.193 1764.2L259.906 1765.95L260.624 1767.7L261.346 1769.46L262.073 1771.23L262.803 1773.02L263.537 1774.81L264.276 1776.61L265.018 1778.42L265.765 1780.24L266.515 1782.08L267.269 1783.92L268.027 1785.77L268.789 1787.63L269.555 1789.5L270.324 1791.37L271.098 1793.26L271.875 1795.16L272.656 1797.06L273.44 1798.98L274.228 1800.9L275.02 1802.83L275.815 1804.78L276.614 1806.72L277.416 1808.68L278.222 1810.65L279.031 1812.63L279.844 1814.61L280.66 1816.6L281.48 1818.6L282.303 1820.61L283.129 1822.63L283.958 1824.65L284.791 1826.68L285.627 1828.72L286.466 1830.77L287.309 1832.83L288.154 1834.89L289.003 1836.96L289.855 1839.04L290.709 1841.13L291.567 1843.22L292.428 1845.32L293.292 1847.43L294.159 1849.55L295.028 1851.67L295.901 1853.8L296.776 1855.94L297.654 1858.08L298.535 1860.23L299.419 1862.39L300.306 1864.55L301.195 1866.72L302.087 1868.9L302.981 1871.08L303.878 1873.27L304.778 1875.47L305.68 1877.67L306.585 1879.88L307.492 1882.09L308.402 1884.31L309.314 1886.54L310.229 1888.77L311.146 1891.01L312.065 1893.25L312.987 1895.5L313.911 1897.76L314.837 1900.02L315.766 1902.29L316.697 1904.56L317.629 1906.84L318.564 1909.12L319.502 1911.4L320.441 1913.7L321.382 1915.99L322.325 1918.3L323.271 1920.6L324.218 1922.92L325.167 1925.23L326.118 1927.55L327.072 1929.88L328.026 1932.21L328.983 1934.55L329.942 1936.89L330.902 1939.23L331.864 1941.58L332.828 1943.93L333.793 1946.29L334.76 1948.65L335.729 1951.01L336.699 1953.38L337.671 1955.75L338.644 1958.13L339.619 1960.51L340.596 1962.89L341.573 1965.28L342.553 1967.67L343.533 1970.06L344.515 1972.46L345.498 1974.86L346.483 1977.26L347.469 1979.67L348.456 1982.08L349.444 1984.49L350.434 1986.9L351.424 1989.32L352.416 1991.74L353.409 1994.16L354.403 1996.59L355.398 1999.02L356.393 2001.45L357.39 2003.88L358.388 2006.32L359.387 2008.76L360.387 2011.2L361.387 2013.64L362.388 2016.08L363.391 2018.53L364.394 2020.98L365.397 2023.43L366.402 2025.88L367.407 2028.33L368.412 2030.79L369.419 2033.24L370.426 2035.7L371.433 2038.16L372.441 2040.62L373.45 2043.08L374.459 2045.54L375.468 2048.01L376.478 2050.47L377.488 2052.94L378.499 2055.4L379.51 2057.87L380.521 2060.34L381.532 2062.81L382.544 2065.28L383.556 2067.75L384.568 2070.22L385.58 2072.69L386.593 2075.16L387.605 2077.63L388.618 2080.1L389.631 2082.57L390.643 2085.05L391.656 2087.52L392.668 2089.99L393.681 2092.46L394.693 2094.93L395.705 2097.4L396.718 2099.87L397.729 2102.34L398.741 2104.81L399.752 2107.28L400.763 2109.75L401.774 2112.21L402.785 2114.68L403.795 2117.15L404.804 2119.61L405.814 2122.07L406.822 2124.54L407.831 2127L408.838 2129.46L409.845 2131.91L410.852 2134.37L411.858 2136.83L412.863 2139.28L413.868 2141.73L414.872 2144.18L415.875 2146.63L416.878 2149.08L417.88 2151.52L418.88 2153.97L419.881 2156.41L420.88 2158.85L421.878 2161.28L422.875 2163.72L423.872 2166.15L424.867 2168.58L425.862 2171.01L426.855 2173.43L427.847 2175.85L428.838 2178.27L429.828 2180.69L430.817 2183.1L431.805 2185.51L432.791 2187.92L433.777 2190.32L434.76 2192.73L435.743 2195.12L436.724 2197.52L437.704 2199.91L438.683 2202.3L439.66 2204.68L440.635 2207.07L441.609 2209.44L442.582 2211.82L443.553 2214.19L444.522 2216.55L445.49 2218.92L446.456 2221.27L447.421 2223.63L448.384 2225.98L449.345 2228.32L450.304 2230.67L451.262 2233L452.218 2235.34L453.171 2237.66L454.124 2239.99L455.074 2242.31L456.022 2244.62L456.968 2246.93L457.912 2249.24L458.855 2251.54L459.795 2253.83L460.733 2256.12L461.669 2258.4L462.603 2260.68L463.535 2262.96L464.464 2265.23L465.392 2267.49L466.317 2269.75L467.24 2272L468.16 2274.25L469.078 2276.49L469.994 2278.72L470.907 2280.95L471.818 2283.18L472.727 2285.39L473.633 2287.61L474.536 2289.81L475.437 2292.01L476.336 2294.2L477.231 2296.39L478.124 2298.57L479.015 2300.74L479.903 2302.91L480.788 2305.07L481.67 2307.22L482.55 2309.37L483.426 2311.51L484.3 2313.64L485.171 2315.77L486.039 2317.89L486.905 2320L487.767 2322.1L488.626 2324.2L489.482 2326.29L490.336 2328.37L491.186 2330.45L492.033 2332.52L492.877 2334.57L493.717 2336.63L494.555 2338.67L495.389 2340.71L496.22 2342.74L497.048 2344.76L497.872 2346.77L498.694 2348.77L499.511 2350.77L500.326 2352.76L501.137 2354.74L501.944 2356.71L502.748 2358.67L503.549 2360.62L504.346 2362.57L505.139 2364.51L505.929 2366.43L506.715 2368.35L507.498 2370.26L508.276 2372.16L509.051 2374.05L509.823 2375.94L510.59 2377.81L511.354 2379.67L512.114 2381.53L512.87 2383.38L513.622 2385.21L514.371 2387.04L515.115 2388.85L515.855 2390.66L516.591 2392.46L517.324 2394.25L518.052 2396.02L518.776 2397.79L519.496 2399.55L520.212 2401.29L520.923 2403.03L521.631 2404.76L522.334 2406.47L523.033 2408.18L523.727 2409.88L524.418 2411.56L525.103 2413.23L525.785 2414.9L526.462 2416.55L527.135 2418.19L527.803 2419.82L528.466 2421.44L529.125 2423.05L529.78 2424.65L530.43 2426.23L531.075 2427.81L531.716 2429.37L532.352 2430.93L532.983 2432.47L533.609 2433.99L534.231 2435.51L534.848 2437.02L535.46 2438.51L536.067 2439.99L536.67 2441.46L537.267 2442.92L537.859 2444.37L538.447 2445.8L539.029 2447.22L539.607 2448.63L540.179 2450.03L540.746 2451.41L541.308 2452.79L541.865 2454.15L542.417 2455.49L542.964 2456.83L543.505 2458.15L544.041 2459.46L544.572 2460.75L545.097 2462.03L545.617 2463.3L546.132 2464.56L546.641 2465.8L547.145 2467.03L547.643 2468.25L548.136 2469.45L548.623 2470.64L549.105 2471.82L549.581 2472.98L550.052 2474.13L550.517 2475.26L550.976 2476.38L551.429 2477.49L551.877 2478.58L552.319 2479.66L552.755 2480.72L553.185 2481.78L553.61 2482.81L554.028 2483.83L554.441 2484.84L554.847 2485.83L555.248 2486.81L555.643 2487.77L556.031 2488.72L556.414 2489.66L556.791 2490.58L557.161 2491.48L557.525 2492.37L557.883 2493.24L558.235 2494.1L558.581 2494.94L558.92 2495.77L559.253 2496.59L559.58 2497.38L559.9 2498.16L560.214 2498.93L560.521 2499.68L560.823 2500.42L561.117 2501.14L561.405 2501.84L561.687 2502.53L561.962 2503.2L562.23 2503.85L562.492 2504.49L562.747 2505.11L562.996 2505.72L563.237 2506.31L563.472 2506.88L563.701 2507.44L563.922 2507.98L564.137 2508.51L564.344 2509.01L564.545 2509.5L564.739 2509.98L564.926 2510.43L565.106 2510.87L565.279 2511.29L565.445 2511.7L565.604 2512.09L565.756 2512.46L565.901 2512.81L566.038 2513.15L566.169 2513.47L566.292 2513.77L566.408 2514.05L566.516 2514.31L566.618 2514.56L566.712 2514.79L566.799 2515L566.878 2515.2L566.95 2515.37L567.014 2515.53L567.071 2515.67L567.121 2515.79L567.163 2515.89L567.197 2515.98L567.224 2516.04L567.243 2516.09L567.255 2516.12C567.257 2516.12 567.258 2516.12 570.497 2514.8L567.258 2516.12L568.492 2519.14L571.585 2518.12L651.065 2492.13L651.696 2491.92L652.207 2491.5L649.977 2488.8C652.207 2491.5 652.207 2491.5 652.208 2491.5L652.209 2491.5L652.213 2491.5L652.227 2491.48L652.278 2491.44C652.321 2491.41 652.383 2491.36 652.463 2491.29C652.623 2491.15 652.854 2490.96 653.147 2490.71C653.731 2490.21 654.56 2489.49 655.549 2488.6C657.523 2486.82 660.158 2484.36 662.768 2481.63C665.359 2478.92 668.018 2475.85 669.976 2472.86C670.956 2471.37 671.819 2469.81 672.4 2468.25C672.97 2466.72 673.359 2464.96 673.099 2463.17L673.098 2463.16L673.096 2463.14C672.394 2458.53 670.315 2453.53 668.542 2449.86C667.637 2447.99 666.774 2446.38 666.136 2445.24C665.817 2444.67 665.552 2444.22 665.366 2443.9C665.272 2443.74 665.198 2443.62 665.146 2443.53L665.085 2443.43L665.067 2443.4L665.062 2443.39L665.06 2443.39L665.059 2443.39C665.059 2443.39 665.059 2443.39 662.076 2445.22L665.059 2443.39L663.464 2440.79L660.673 2442.01L589.313 2473.26L244.784 1636.16L320.29 1605.22L323.348 1603.97L322.273 1600.85L318.963 1601.98C322.273 1600.85 322.273 1600.84 322.272 1600.84L322.272 1600.84L322.269 1600.83L322.261 1600.81L322.232 1600.73C322.208 1600.66 322.173 1600.56 322.127 1600.44C322.036 1600.18 321.903 1599.82 321.73 1599.37C321.383 1598.46 320.874 1597.18 320.214 1595.66C318.9 1592.62 316.965 1588.58 314.504 1584.65C312.069 1580.75 308.984 1576.73 305.299 1573.95C301.558 1571.12 296.884 1569.36 291.666 1570.79C283.698 1572.96 265.042 1580.62 248.668 1587.59C240.416 1591.1 232.647 1594.48 226.942 1596.98C224.089 1598.23 221.751 1599.26 220.127 1599.98C219.314 1600.34 218.68 1600.62 218.248 1600.82Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M365.759 1240.95L431.364 1403",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M397.484 1227.95L463.314 1389.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M299.383 1268.14L365.214 1430.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M331.333 1255.06L396.939 1417.11",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M495.584 1187.76L561.415 1349.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M527.534 1174.67L593.14 1336.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M429.434 1214.86L495.039 1376.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M461.384 1201.77L526.989 1363.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M631.711 1131.99L697.316 1294.04",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M663.661 1118.9L729.266 1280.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M565.56 1159.09L631.166 1321.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M597.285 1146.09L663.116 1308.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M767.837 1076.22L833.442 1238.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M802.712 1061.93L868.317 1223.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M695.611 1105.81L761.217 1267.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M730.261 1091.61L796.092 1253.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M901.488 1021.46L967.093 1183.51",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M933.213 1008.46L999.043 1170.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M835.112 1048.65L900.943 1210.61",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M867.062 1035.56L932.668 1197.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.61 965.688L1103.22 1127.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.34 952.691L1135.17 1114.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M971.238 992.882L1037.07 1154.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.19 979.794L1068.79 1141.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.44 912.497L1233.04 1074.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.39 899.407L1264.99 1061.46",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.29 939.598L1166.89 1101.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.24 926.509L1198.84 1088.56",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.71 855.434L1372.32 1017.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.44 842.437L1404.27 1004.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.34 882.628L1306.17 1044.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.29 869.54L1337.9 1031.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.67 794.407L1521.27 956.46",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.54 780.118L1556.15 942.171",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.22 824.091L1448.82 986.143",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.09 809.802L1483.7 971.854",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.09 739.745L1654.92 901.706",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.04 726.653L1686.65 888.706",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.94 766.847L1588.77 928.807",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M1554.89 753.759L1620.5 915.811",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M1725.22 683.972L1791.05 845.932",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.17 670.884L1822.77 832.936",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M1659.07 711.075L1724.67 873.128",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.02 697.985L1756.62 860.038",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.27 630.688L1920.87 792.741",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1887.22 617.598L1952.82 779.651",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.12 657.79L1854.72 819.843",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.84 644.792L1886.67 806.753",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1994.32 573.718L2060.15 735.679",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M2026.27 560.63L2091.88 722.682",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1928.17 600.821L1993.77 762.874",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M1960.12 587.731L2025.72 749.784",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M2123.02 520.988L2188.85 682.948",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M2154.97 507.899L2220.58 669.952",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M2056.87 548.091L2122.48 710.143",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M2088.82 535.001L2154.43 697.054",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M2259.15 465.218L2324.98 627.179",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M2291.1 452.13L2356.7 614.182",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M2193 492.321L2258.6 654.374",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M2224.95 479.231L2290.55 641.284",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M2405.51 494.07L327.28 1348.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M2341.55 503.455L2325.26 509.867",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M2333.06 494.362L2336.31 493.041L2334.98 489.8L2328.28 473.363L2326.96 470.122L2323.72 471.443L2312.24 476.123L2309 477.444L2310.32 480.685L2317.02 497.123L2318.34 500.364L2321.58 499.043L2333.06 494.362Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M2332.16 508.095L2327.18 495.945",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M2394.88 481.607L2378.59 488.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M2386.4 472.511L2389.64 471.19L2388.32 467.948L2381.62 451.511L2380.3 448.27L2377.06 449.591L2365.57 454.272L2362.33 455.593L2363.65 458.834L2370.35 475.271L2371.67 478.512L2374.92 477.191L2386.4 472.511Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M2385.48 486.248L2380.5 474.098",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M2345.03 427.926L2321.41 437.605L2354.23 517.706L2377.85 508.027L2345.03 427.926Z",
    fill: "#9C9C9C"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M2354.83 535.855L2338.63 542.492",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M2364.46 570.873L2367.69 569.54L2366.36 566.304L2359.6 549.891L2358.27 546.655L2355.03 547.988L2343.57 552.71L2340.33 554.043L2341.66 557.279L2348.42 573.692L2349.75 576.928L2352.99 575.595L2364.46 570.873Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.79 538.922L2349.86 551.297",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M2408.15 514.007L2391.95 520.645",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M2417.79 549.021L2421.03 547.689L2419.7 544.452L2412.94 528.039L2411.6 524.803L2408.37 526.136L2396.9 530.858L2393.66 532.191L2395 535.427L2401.76 551.84L2403.09 555.076L2406.33 553.744L2417.79 549.021Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M2398.11 517.074L2403.18 529.449",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M2377.39 506.903L2353.77 516.582L2386.58 596.683L2410.21 587.003L2377.39 506.903Z",
    fill: "#9C9C9C"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M2374.77 415.219L2442.01 577.393",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M472.784 1502.18L538.389 1664.23",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M504.509 1489.18L570.34 1651.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M406.409 1529.37L472.239 1691.33",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M438.359 1516.28L503.964 1678.33",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M602.61 1448.98L668.44 1610.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M634.56 1435.9L700.165 1597.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M536.459 1476.09L602.065 1638.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M568.409 1463L634.015 1625.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M738.736 1393.22L804.341 1555.27",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M770.686 1380.13L836.291 1542.18",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M672.585 1420.32L738.191 1582.37",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M704.31 1407.32L770.141 1569.28",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M874.862 1337.44L940.467 1499.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M909.737 1323.15L975.342 1485.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M802.636 1367.03L868.241 1529.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M837.286 1352.84L903.116 1514.8",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.51 1282.68L1074.12 1444.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.24 1269.69L1106.07 1431.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M942.137 1309.88L1007.97 1471.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M974.087 1296.79L1039.69 1458.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.64 1226.91L1210.24 1388.97",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.36 1213.92L1242.19 1375.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.26 1254.11L1144.09 1416.07",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 1241.02L1175.82 1403.07",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.46 1173.72L1340.07 1335.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.41 1160.63L1372.02 1322.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.31 1200.83L1273.92 1362.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.26 1187.74L1305.87 1349.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.74 1116.66L1479.35 1278.71",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.47 1103.66L1511.3 1265.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.37 1143.85L1413.2 1305.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.32 1130.77L1444.92 1292.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.69 1055.63L1628.3 1217.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.57 1041.34L1663.17 1203.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.24 1085.32L1555.85 1247.37",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.12 1071.03L1590.72 1233.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.12 1000.97L1761.95 1162.93",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.07 987.88L1793.67 1149.93",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.97 1028.07L1695.8 1190.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M1661.92 1014.99L1727.52 1177.04",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M1832.24 945.198L1898.07 1107.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M1864.19 932.11L1929.8 1094.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M1766.09 972.302L1831.7 1134.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.04 959.212L1863.65 1121.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M1962.29 891.915L2027.9 1053.97",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M1994.24 878.825L2059.85 1040.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M1896.14 919.016L1961.75 1081.07",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M1927.87 906.019L1993.7 1067.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M2101.35 834.945L2167.18 996.905",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M2133.3 821.856L2198.9 983.909",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M2035.19 862.048L2100.8 1024.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M2067.15 848.958L2132.75 1011.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M2230.05 782.214L2295.88 944.175",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M2262 769.126L2327.6 931.179",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M2163.9 809.317L2229.5 971.37",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M2195.85 796.227L2261.45 958.28",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M2366.17 726.445L2432 888.405",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M2398.12 713.356L2463.73 875.409",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M2300.02 753.548L2365.63 915.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M2331.97 740.458L2397.58 902.511",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M2512.53 755.297L434.213 1609.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M2448.49 764.457L2432.29 771.094",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M2440.01 755.401L2443.26 754.08L2441.93 750.839L2435.23 734.402L2433.91 731.161L2430.67 732.482L2419.19 737.162L2415.95 738.483L2417.27 741.725L2423.97 758.162L2425.29 761.403L2428.53 760.082L2440.01 755.401Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M2439.18 769.32L2434.11 756.945",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M2501.81 742.609L2485.61 749.246",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M2493.35 733.55L2496.59 732.229L2495.27 728.988L2488.57 712.55L2487.25 709.309L2484.01 710.63L2472.52 715.311L2469.28 716.632L2470.6 719.873L2477.3 736.31L2478.62 739.551L2481.86 738.23L2493.35 733.55Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M2492.51 747.473L2487.44 735.098",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M2452.06 689.153L2428.44 698.832L2461.25 778.933L2484.88 769.253L2452.06 689.153Z",
    fill: "#9C9C9C"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M2461.76 796.859L2445.66 803.721",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M2471.5 832.135L2474.74 830.802L2473.4 827.566L2466.64 811.153L2465.31 807.916L2462.07 809.249L2450.61 813.972L2447.37 815.304L2448.7 818.541L2455.46 834.954L2456.8 838.19L2460.03 836.857L2471.5 832.135Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M2451.81 800.148L2456.79 812.299",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M2515.09 775.011L2498.98 781.873",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M2524.83 810.283L2528.07 808.95L2526.74 805.714L2519.98 789.301L2518.65 786.065L2515.41 787.398L2503.94 792.12L2500.71 793.453L2502.04 796.689L2508.8 813.102L2510.13 816.338L2513.37 815.005L2524.83 810.283Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M2505.14 778.301L2510.12 790.451",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M2484.42 768.129L2460.79 777.809L2493.61 857.909L2517.23 848.23L2484.42 768.129Z",
    fill: "#9C9C9C"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M2481.8 676.441L2549.03 838.616",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M575.201 1752.15L640.806 1914.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M606.926 1739.16L672.757 1901.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M508.826 1779.35L574.656 1941.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M540.776 1766.26L606.381 1928.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M705.027 1698.96L770.857 1860.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M736.977 1685.87L802.582 1847.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M638.876 1726.06L704.482 1888.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M670.826 1712.97L736.432 1875.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M841.153 1643.19L906.758 1805.24",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M873.103 1630.1L938.708 1792.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M775.002 1670.29L840.608 1832.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M806.727 1657.3L872.558 1819.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M977.278 1587.42L1042.88 1749.47",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.15 1573.13L1077.76 1735.18",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M905.053 1617.01L970.658 1779.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M939.703 1602.81L1005.53 1764.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.93 1532.66L1176.53 1694.71",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.65 1519.66L1208.49 1681.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.55 1559.85L1110.38 1721.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.5 1546.77L1142.11 1708.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.06 1476.89L1312.66 1638.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.78 1463.89L1344.61 1625.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.68 1504.09L1246.51 1666.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.63 1491L1278.24 1653.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.88 1423.7L1442.49 1585.75",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.83 1410.61L1474.44 1572.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.73 1450.8L1376.34 1612.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.68 1437.71L1408.29 1599.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M1516.16 1366.64L1581.76 1528.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.88 1353.64L1613.71 1515.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.78 1393.83L1515.61 1555.79",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M1481.73 1380.74L1547.34 1542.8",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M1665.11 1305.61L1730.71 1467.66",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M1699.98 1291.32L1765.59 1453.37",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.66 1335.29L1658.26 1497.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.53 1321L1693.14 1483.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.53 1250.94L1864.36 1412.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M1830.48 1237.85L1896.09 1399.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M1732.38 1278.05L1798.21 1440.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M1764.33 1264.96L1829.94 1427.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M1934.66 1195.17L2000.49 1357.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M1966.61 1182.09L2032.22 1344.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M1868.51 1222.28L1934.12 1384.33",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M1900.46 1209.19L1966.07 1371.24",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M2064.71 1141.89L2130.32 1303.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.66 1128.8L2162.27 1290.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M1998.56 1168.99L2064.17 1331.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M2030.29 1156L2096.12 1317.96",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M2203.76 1084.92L2269.59 1246.88",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M2235.71 1071.83L2301.32 1233.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M2137.61 1112.02L2203.22 1274.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M2169.56 1098.93L2235.17 1260.99",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M2332.46 1032.19L2398.29 1194.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M2364.41 1019.1L2430.02 1181.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1059.29L2331.92 1221.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M2298.26 1046.2L2363.87 1208.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M2468.59 976.421L2534.42 1138.38",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M2500.54 963.333L2566.14 1125.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M2402.44 1003.52L2468.04 1165.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M2434.39 990.434L2499.99 1152.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M2614.95 1005.27L536.723 1859.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M2551 1014.66L2534.8 1021.3",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M2542.53 1005.62L2545.77 1004.3L2544.45 1001.06L2537.75 984.624L2536.43 981.383L2533.19 982.704L2521.71 987.385L2518.46 988.706L2519.79 991.947L2526.49 1008.38L2527.81 1011.63L2531.05 1010.3L2542.53 1005.62Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M2541.6 1019.3L2536.62 1007.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M2604.32 992.812L2588.12 999.449",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M2595.87 983.772L2599.11 982.451L2597.79 979.21L2591.09 962.773L2589.77 959.532L2586.52 960.853L2575.04 965.533L2571.8 966.854L2573.12 970.095L2579.82 986.533L2581.14 989.774L2584.38 988.453L2595.87 983.772Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M2594.93 997.451L2589.95 985.301",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M2554.48 939.129L2530.85 948.809L2563.67 1028.91L2587.29 1019.23L2554.48 939.129Z",
    fill: "#9C9C9C"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M2564.27 1047.05L2548.07 1053.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M2573.92 1082.13L2577.16 1080.8L2575.83 1077.56L2569.07 1061.15L2567.74 1057.91L2564.5 1059.25L2553.03 1063.97L2549.8 1065.3L2551.13 1068.54L2557.89 1084.95L2559.22 1088.19L2562.46 1086.85L2573.92 1082.13Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M2554.23 1050.12L2559.3 1062.5",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M2617.6 1025.21L2601.4 1031.84",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M2627.26 1060.28L2630.5 1058.95L2629.16 1055.71L2622.4 1039.3L2621.07 1036.06L2617.83 1037.39L2606.37 1042.12L2603.13 1043.45L2604.46 1046.69L2611.22 1063.1L2612.56 1066.33L2615.79 1065L2627.26 1060.28Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M2607.55 1028.27L2612.62 1040.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M2586.93 1018.33L2563.3 1028.01L2596.12 1108.11L2619.74 1098.43L2586.93 1018.33Z",
    fill: "#9C9C9C"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M2584.22 926.418L2651.45 1088.59",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M680.752 2009.78L746.357 2171.83",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M712.477 1996.78L778.307 2158.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M614.376 2036.98L680.207 2198.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M646.326 2023.89L711.932 2185.94",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M810.577 1956.59L876.408 2118.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M842.528 1943.5L908.133 2105.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M744.427 1983.69L810.032 2145.74",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M776.377 1970.6L841.983 2132.65",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M946.703 1900.82L1012.31 2062.87",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M978.653 1887.73L1044.26 2049.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M880.553 1927.92L946.158 2089.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M912.278 1914.92L978.109 2076.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.83 1845.05L1148.43 2007.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.7 1830.76L1183.31 1992.81",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.6 1874.64L1076.21 2036.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.25 1860.44L1111.08 2022.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.48 1790.29L1282.09 1952.34",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.21 1777.29L1314.04 1939.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.1 1817.48L1215.94 1979.44",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.05 1804.4L1247.66 1966.45",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.61 1734.52L1418.21 1896.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.33 1721.52L1450.16 1883.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.23 1761.71L1352.06 1923.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.18 1748.63L1383.79 1910.68",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.43 1681.33L1548.04 1843.38",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.38 1668.24L1579.99 1830.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.28 1708.43L1481.89 1870.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.23 1695.34L1513.84 1857.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.71 1624.27L1687.31 1786.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.43 1611.27L1719.26 1773.23",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M1555.33 1651.46L1621.16 1813.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.28 1638.37L1652.89 1800.42",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M1770.66 1563.24L1836.26 1725.29",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M1805.53 1548.95L1871.14 1711",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M1698.21 1592.92L1763.81 1754.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M1733.08 1578.63L1798.69 1740.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M1904.09 1508.57L1969.92 1670.53",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M1936.04 1495.48L2001.64 1657.53",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M1837.93 1535.67L1903.77 1697.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.88 1522.59L1935.49 1684.64",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M2040.21 1452.8L2106.04 1614.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M2072.16 1439.72L2137.77 1601.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M1974.06 1479.91L2039.67 1641.96",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M2006.01 1466.82L2071.62 1628.87",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M2170.26 1399.52L2235.87 1561.57",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M2202.21 1386.43L2267.82 1548.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M2104.11 1426.62L2169.72 1588.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M2135.84 1413.62L2201.67 1575.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M2309.31 1342.55L2375.14 1504.51",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M2341.26 1329.46L2406.87 1491.51",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M2243.16 1369.65L2308.77 1531.71",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M2275.11 1356.56L2340.72 1518.62",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M2438.01 1289.82L2503.84 1451.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M2469.96 1276.73L2535.57 1438.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M2371.86 1316.92L2437.47 1478.98",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M2403.81 1303.83L2469.42 1465.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M2574.14 1234.05L2639.97 1396.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M2606.09 1220.96L2671.7 1383.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M2507.99 1261.15L2573.59 1423.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M2539.94 1248.06L2605.55 1410.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M2720.41 1262.68L642.181 2117.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M2656.46 1272.06L2640.26 1278.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M2648.03 1263.13L2651.28 1261.81L2649.95 1258.57L2643.25 1242.13L2641.93 1238.89L2638.69 1240.21L2627.21 1244.89L2623.97 1246.21L2625.29 1249.45L2631.99 1265.89L2633.31 1269.13L2636.55 1267.81L2648.03 1263.13Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M2647.06 1276.7L2642.08 1264.55",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M2709.78 1250.21L2693.58 1256.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M2701.37 1241.28L2704.61 1239.96L2703.29 1236.72L2696.59 1220.28L2695.27 1217.04L2692.03 1218.36L2680.54 1223.04L2677.3 1224.36L2678.62 1227.6L2685.32 1244.04L2686.64 1247.28L2689.88 1245.96L2701.37 1241.28Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M2700.38 1254.85L2695.41 1242.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M2659.94 1196.53L2636.31 1206.21L2669.13 1286.31L2692.75 1276.63L2659.94 1196.53Z",
    fill: "#9C9C9C"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M2669.73 1304.46L2653.53 1311.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M2679.43 1339.65L2682.66 1338.31L2681.33 1335.08L2674.57 1318.66L2673.24 1315.43L2670 1316.76L2658.54 1321.48L2655.3 1322.82L2656.63 1326.05L2663.39 1342.47L2664.73 1345.7L2667.96 1344.37L2679.43 1339.65Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M2659.78 1307.75L2664.76 1319.9",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M2723.06 1282.62L2706.86 1289.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M2732.76 1317.79L2736 1316.46L2734.67 1313.23L2727.91 1296.81L2726.57 1293.58L2723.34 1294.91L2711.87 1299.63L2708.63 1300.96L2709.97 1304.2L2716.73 1320.61L2718.06 1323.85L2721.3 1322.52L2732.76 1317.79Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M2713.1 1285.91L2718.08 1298.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M2692.38 1275.73L2668.76 1285.41L2701.58 1365.51L2725.2 1355.84L2692.38 1275.73Z",
    fill: "#9C9C9C"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M2689.77 1184.05L2756.91 1346",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M781.694 2256.16L847.299 2418.21",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M813.419 2243.16L879.249 2405.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M715.318 2283.35L781.149 2445.31",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M747.268 2270.26L812.874 2432.32",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M911.519 2202.96L977.35 2364.92",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M943.469 2189.88L1009.07 2351.93",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M845.369 2230.07L910.974 2392.12",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M877.319 2216.98L942.924 2379.03",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.65 2147.2L1113.25 2309.25",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.6 2134.11L1145.2 2296.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M981.495 2174.3L1047.1 2336.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.22 2161.3L1079.05 2323.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.77 2091.42L1249.38 2253.48",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.65 2077.13L1284.25 2239.19",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.55 2121.01L1177.15 2283.07",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.2 2106.82L1212.03 2268.78",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.42 2036.66L1383.03 2198.72",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M1349.15 2023.67L1414.98 2185.63",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.05 2063.86L1316.88 2225.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M1283 2050.77L1348.6 2212.82",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.55 1980.9L1519.15 2142.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.27 1967.9L1551.1 2129.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.17 2008.09L1453 2170.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M1419.12 1995L1484.73 2157.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M1583.37 1927.7L1648.98 2089.76",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M1615.32 1914.61L1680.93 2076.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.22 1954.81L1582.83 2116.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M1549.17 1941.72L1614.78 2103.77",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M1722.65 1870.64L1788.26 2032.69",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.38 1857.64L1820.21 2019.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M1656.27 1897.84L1722.11 2059.8",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M1688.23 1884.75L1753.83 2046.8",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.6 1809.61L1937.21 1971.67",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.48 1795.33L1972.08 1957.38",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M1799.15 1839.3L1864.76 2001.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M1834.03 1825.01L1899.63 1987.06",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M2005.03 1754.95L2070.86 1916.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M2036.98 1741.86L2102.58 1903.91",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M1938.88 1782.05L2004.71 1944.01",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M1970.83 1768.97L2036.43 1931.02",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M2141.15 1699.18L2206.98 1861.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M2173.1 1686.09L2238.71 1848.14",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M2075 1726.28L2140.61 1888.33",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M2106.95 1713.19L2172.56 1875.24",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M2271.2 1645.9L2336.81 1807.95",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M2303.15 1632.81L2368.76 1794.86",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M2205.05 1673L2270.66 1835.05",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M2236.78 1660L2302.61 1821.96",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M2410.26 1588.92L2476.09 1750.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M2442.21 1575.84L2507.81 1737.89",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.1 1616.03L2409.71 1778.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M2376.05 1602.94L2441.66 1764.99",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M2538.96 1536.19L2604.79 1698.15",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M2570.91 1523.11L2636.51 1685.16",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M2472.81 1563.3L2538.41 1725.35",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M2504.76 1550.21L2570.36 1712.26",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M2675.08 1480.43L2740.91 1642.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M2707.03 1467.34L2772.64 1629.39",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M2608.93 1507.53L2674.54 1669.58",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M2640.88 1494.44L2706.49 1656.49",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M2821.44 1509.28L743.123 2363.4",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M2757.4 1518.44L2741.2 1525.07",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M2748.92 1509.37L2752.16 1508.05L2750.84 1504.81L2744.14 1488.37L2742.82 1485.13L2739.58 1486.45L2728.1 1491.14L2724.85 1492.46L2726.18 1495.7L2732.88 1512.13L2734.2 1515.38L2737.44 1514.05L2748.92 1509.37Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M2748.09 1523.3L2743.02 1510.93",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M2810.72 1496.59L2794.52 1503.23",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M2802.26 1487.52L2805.5 1486.2L2804.18 1482.96L2797.48 1466.52L2796.16 1463.28L2792.91 1464.6L2781.43 1469.28L2778.19 1470.6L2779.51 1473.85L2786.21 1490.28L2787.53 1493.52L2790.77 1492.2L2802.26 1487.52Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M2801.42 1501.45L2796.35 1489.08",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M2760.97 1443.13L2737.34 1452.81L2770.16 1532.91L2793.79 1523.23L2760.97 1443.13Z",
    fill: "#9C9C9C"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M2770.67 1550.84L2754.57 1557.7",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M2780.41 1586.11L2783.64 1584.78L2782.31 1581.54L2775.55 1565.13L2774.22 1561.89L2770.98 1563.23L2759.52 1567.95L2756.28 1569.28L2757.61 1572.52L2764.37 1588.93L2765.7 1592.17L2768.94 1590.83L2780.41 1586.11Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M2760.72 1554.13L2765.7 1566.28",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M2824 1528.99L2807.89 1535.85",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M2833.74 1564.26L2836.98 1562.93L2835.64 1559.69L2828.89 1543.28L2827.55 1540.04L2824.32 1541.37L2812.85 1546.1L2809.61 1547.43L2810.95 1550.67L2817.71 1567.08L2819.04 1570.31L2822.28 1568.98L2833.74 1564.26Z",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M2814.05 1532.28L2819.02 1544.43",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M2793.33 1522.11L2769.7 1531.79L2802.52 1611.89L2826.14 1602.21L2793.33 1522.11Z",
    fill: "#9C9C9C"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M2790.71 1430.42L2857.94 1592.6",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1020-outside-3_900_5434",
    maskUnits: "userSpaceOnUse",
    x: 500.901,
    y: 2548.39,
    width: 99.0622,
    height: 108.348,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 500.901,
    y: 2548.39,
    width: 99.0622,
    height: 108.348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.431 2553.08C560.431 2553.08 571.59 2570.06 553.129 2614.15C534.667 2658.24 538.313 2645.97 538.313 2645.97"
  }))), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M560.431 2553.08C560.431 2553.08 571.59 2570.06 553.129 2614.15C534.667 2658.24 538.313 2645.97 538.313 2645.97",
    fill: "white"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M560.431 2553.08C554.582 2556.93 554.578 2556.92 554.575 2556.92C554.574 2556.91 554.57 2556.91 554.568 2556.91C554.563 2556.9 554.559 2556.89 554.555 2556.89C554.546 2556.87 554.539 2556.86 554.532 2556.85C554.518 2556.83 554.506 2556.81 554.498 2556.8C554.48 2556.77 554.473 2556.75 554.475 2556.76C554.479 2556.76 554.519 2556.84 554.586 2556.97C554.721 2557.25 554.965 2557.79 555.243 2558.63C555.798 2560.3 556.501 2563.17 556.712 2567.43C557.132 2575.93 555.588 2590.15 546.672 2611.44L559.586 2616.85C569.131 2594.05 571.238 2577.74 570.695 2566.74C570.423 2561.23 569.49 2557.11 568.529 2554.22C568.05 2552.77 567.567 2551.65 567.163 2550.82C566.961 2550.41 566.78 2550.07 566.629 2549.81C566.554 2549.68 566.486 2549.56 566.428 2549.47C566.398 2549.42 566.371 2549.38 566.347 2549.34C566.335 2549.32 566.323 2549.3 566.312 2549.29C566.306 2549.28 566.301 2549.27 566.296 2549.26C566.293 2549.26 566.289 2549.25 566.288 2549.25C566.284 2549.24 566.281 2549.24 560.431 2553.08ZM546.672 2611.44C537.372 2633.65 533.853 2641.13 532.719 2643.12C532.6 2643.33 532.603 2643.3 532.707 2643.16C532.758 2643.09 532.91 2642.88 533.155 2642.62C533.322 2642.45 533.94 2641.8 534.968 2641.28C536.035 2640.74 538.794 2639.79 541.691 2641.54C544.099 2643 544.699 2645.27 544.83 2645.8C545.021 2646.58 545.022 2647.2 545.02 2647.42C545.018 2647.7 544.996 2647.9 544.985 2648C544.953 2648.27 544.919 2648.36 544.975 2648.14C544.99 2648.08 545.005 2648.03 545.016 2647.99C545.021 2647.97 545.025 2647.95 545.026 2647.95C545.027 2647.95 545.027 2647.95 545.027 2647.95C545.026 2647.95 545.026 2647.95 545.025 2647.95C545.025 2647.95 545.024 2647.96 545.024 2647.96C545.024 2647.96 545.023 2647.96 545.023 2647.96C545.023 2647.96 545.023 2647.96 538.313 2645.97C531.603 2643.97 531.602 2643.98 531.602 2643.98C531.602 2643.98 531.601 2643.98 531.601 2643.98C531.6 2643.98 531.6 2643.98 531.599 2643.99C531.597 2643.99 531.596 2644 531.594 2644C531.59 2644.02 531.585 2644.03 531.579 2644.05C531.568 2644.09 531.553 2644.14 531.537 2644.2C531.503 2644.32 531.458 2644.49 531.409 2644.68C531.338 2644.96 531.163 2645.66 531.078 2646.39C531.063 2646.52 530.89 2647.74 531.231 2649.13C531.377 2649.73 532 2652.04 534.442 2653.52C537.372 2655.29 540.175 2654.34 541.297 2653.77C542.381 2653.22 543.066 2652.52 543.314 2652.26C543.639 2651.91 543.885 2651.59 544.045 2651.37C544.366 2650.93 544.646 2650.46 544.876 2650.06C546.535 2647.16 550.424 2638.73 559.586 2616.85L546.672 2611.44Z",
    fill: "#9C9C9C",
    mask: "url(#path-1020-outside-3_900_5434)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M663.994 2512.75L622.868 2622.1",
    stroke: "#9C9C9C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M704.31 1411.34L675.31 1423.34L705.31 1495.84L734.31 1483.84L704.31 1411.34Z",
    fill: "#FF5910"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M738.31 1397.34L707.31 1410.34L737.31 1482.84L767.81 1470.34L738.31 1397.34Z",
    fill: "#FF5910"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M963.81 1088.84L934.81 1100.84L967.81 1179.84L996.31 1168.34L963.81 1088.84Z",
    fill: "#FF5910"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.31 1516.34L1342.81 1529.84L1379.31 1617.84L1410.81 1603.34L1373.31 1516.34Z",
    fill: "#FF1717"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.31 1884.84L1184.31 1896.34L1216.81 1978.84L1245.81 1966.84L1212.31 1884.84Z",
    fill: "#FF1717"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M1931.31 1285.84L1900.81 1299.34L1937.31 1387.34L1969.31 1374.84L1931.31 1285.84Z",
    fill: "#FF1717"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.81 1032.84L1071.31 1044.34L1103.81 1124.84L1132.31 1113.34L1099.81 1032.84Z",
    fill: "#FF5910"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M1511.81 1460.34L1482.31 1472.34L1518.81 1559.84L1548.31 1547.34L1511.81 1460.34Z",
    fill: "#FF1717"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.31 1826.84L1318.81 1838.84L1353.31 1922.34L1383.31 1910.34L1348.31 1826.84Z",
    fill: "#FF1717"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M2060.81 1235.84L2031.31 1247.84L2067.81 1335.34L2097.31 1322.84L2060.81 1235.84Z",
    fill: "#FF1717"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.31 715.84L1143.81 727.34L1176.31 807.84L1204.81 796.34L1172.31 715.84Z",
    fill: "#FF5910"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M909.81 825.34L879.31 836.84L908.31 910.84L937.81 899.34L909.81 825.34Z",
    fill: "#FF5910"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M638.81 934.84L607.81 947.34L636.81 1019.84L667.31 1008.34L638.81 934.84Z",
    fill: "#FF5910"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M630.31 1128.84L597.81 1142.34L630.31 1222.84L661.81 1209.84L630.31 1128.84Z",
    fill: "#FF5910"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31 1637.84L257.81 1666.84L271.81 1700.84L345.81 1671.34L332.31 1637.84Z",
    fill: "#6CDD59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 781,
    y: 2518.58,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 781 2518.58)",
    fill: "#FE763B"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M874.408 2570.81L862 2540.53L870.222 2537.16L879.915 2560.82L892.159 2555.8L894.873 2562.43L874.408 2570.81Z",
    fill: "white"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M909.427 2556.95C906.962 2557.96 904.653 2558.33 902.498 2558.08C900.34 2557.81 898.432 2556.99 896.777 2555.62C895.118 2554.24 893.811 2552.38 892.858 2550.06C891.905 2547.73 891.537 2545.5 891.755 2543.36C891.968 2541.21 892.752 2539.29 894.107 2537.6C895.458 2535.89 897.366 2534.53 899.83 2533.52C902.295 2532.51 904.606 2532.14 906.765 2532.41C908.92 2532.67 910.827 2533.49 912.486 2534.87C914.142 2536.24 915.446 2538.09 916.399 2540.41C917.352 2542.74 917.722 2544.98 917.509 2547.13C917.291 2549.26 916.507 2551.19 915.156 2552.89C913.801 2554.59 911.891 2555.94 909.427 2556.95ZM907.014 2550.89C907.704 2550.61 908.206 2550.13 908.519 2549.46C908.832 2548.79 908.95 2547.97 908.875 2547C908.8 2546.03 908.52 2544.95 908.035 2543.77C907.546 2542.58 906.99 2541.61 906.367 2540.88C905.739 2540.14 905.079 2539.63 904.387 2539.38C903.694 2539.12 903.003 2539.13 902.313 2539.42C901.583 2539.71 901.052 2540.2 900.72 2540.88C900.387 2541.56 900.258 2542.38 900.334 2543.35C900.405 2544.31 900.685 2545.39 901.174 2546.58C901.658 2547.77 902.214 2548.73 902.842 2549.47C903.469 2550.22 904.139 2550.72 904.851 2550.96C905.564 2551.21 906.285 2551.19 907.014 2550.89Z",
    fill: "white"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M928.579 2522.09L931.003 2528.01L916.038 2534.14L913.615 2528.22L928.579 2522.09ZM914.284 2521.59L922.446 2518.25L930.988 2539.1C931.118 2539.41 931.281 2539.66 931.478 2539.83C931.672 2539.99 931.904 2540.08 932.175 2540.1C932.442 2540.1 932.753 2540.03 933.108 2539.89C933.354 2539.79 933.628 2539.64 933.929 2539.45C934.24 2539.25 934.466 2539.1 934.608 2539L938.142 2544.25C937.821 2544.51 937.353 2544.86 936.738 2545.29C936.132 2545.72 935.376 2546.15 934.47 2546.58C932.637 2547.45 930.986 2547.9 929.516 2547.94C928.042 2547.97 926.769 2547.59 925.696 2546.79C924.623 2546 923.772 2544.81 923.141 2543.21L914.284 2521.59Z",
    fill: "white"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M949.393 2540.09L936.986 2509.81L958.279 2501.08L960.993 2507.71L947.922 2513.06L950.054 2518.27L961.825 2513.44L964.539 2520.07L952.768 2524.89L957.615 2536.72L949.393 2540.09Z",
    fill: "white"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M982.006 2526.73L969.599 2496.44L982.671 2491.09C984.918 2490.17 987.067 2489.8 989.116 2490C991.165 2490.2 992.987 2490.91 994.582 2492.13C996.177 2493.35 997.415 2495.04 998.295 2497.19C999.184 2499.36 999.47 2501.43 999.154 2503.42C998.848 2505.4 998.003 2507.17 996.62 2508.74C995.246 2510.3 993.406 2511.56 991.099 2512.5L983.291 2515.7L980.674 2509.31L986.826 2506.79C987.792 2506.4 988.546 2505.89 989.089 2505.28C989.638 2504.65 989.965 2503.95 990.071 2503.17C990.188 2502.38 990.07 2501.56 989.719 2500.7C989.363 2499.84 988.873 2499.17 988.248 2498.72C987.629 2498.24 986.907 2497.99 986.084 2497.94C985.267 2497.89 984.375 2498.06 983.409 2498.45L980.51 2499.64L990.228 2523.36L982.006 2526.73Z",
    fill: "white"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.45 2515.48L1000.15 2492.77L1008.07 2489.52L1009.84 2493.84L1010.08 2493.74C1009.84 2491.98 1010.01 2490.54 1010.61 2489.43C1011.21 2488.32 1012.12 2487.52 1013.33 2487.02C1013.69 2486.88 1014.05 2486.76 1014.42 2486.68C1014.79 2486.58 1015.16 2486.52 1015.53 2486.48L1018.38 2493.45C1017.92 2493.48 1017.38 2493.58 1016.76 2493.75C1016.14 2493.92 1015.62 2494.1 1015.2 2494.27C1014.4 2494.6 1013.75 2495.08 1013.26 2495.7C1012.78 2496.32 1012.49 2497.02 1012.39 2497.82C1012.29 2498.61 1012.41 2499.44 1012.77 2500.31L1017.61 2512.14L1009.45 2515.48Z",
    fill: "white"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.26 2504.57C1034.83 2505.57 1032.55 2505.96 1030.42 2505.75C1028.29 2505.53 1026.4 2504.74 1024.73 2503.38C1023.08 2502.01 1021.75 2500.11 1020.75 2497.66C1019.79 2495.31 1019.42 2493.07 1019.65 2490.93C1019.88 2488.79 1020.65 2486.87 1021.98 2485.19C1023.3 2483.51 1025.14 2482.19 1027.48 2481.22C1029.2 2480.52 1030.86 2480.15 1032.47 2480.11C1034.08 2480.08 1035.58 2480.36 1036.98 2480.98C1038.38 2481.58 1039.64 2482.49 1040.76 2483.71C1041.89 2484.93 1042.82 2486.44 1043.56 2488.25L1044.33 2490.14L1024.04 2498.45L1022.2 2493.96L1034.98 2488.72C1034.7 2488.08 1034.3 2487.57 1033.77 2487.21C1033.25 2486.84 1032.66 2486.63 1032.01 2486.57C1031.36 2486.5 1030.69 2486.61 1030.01 2486.89C1029.35 2487.16 1028.8 2487.55 1028.37 2488.06C1027.93 2488.56 1027.64 2489.13 1027.51 2489.76C1027.39 2490.39 1027.45 2491.03 1027.7 2491.7L1029.69 2496.55C1029.99 2497.28 1030.41 2497.87 1030.95 2498.32C1031.49 2498.76 1032.11 2499.03 1032.81 2499.12C1033.52 2499.22 1034.28 2499.1 1035.08 2498.76C1035.65 2498.53 1036.13 2498.24 1036.53 2497.9C1036.93 2497.55 1037.25 2497.15 1037.46 2496.72C1037.67 2496.28 1037.77 2495.81 1037.75 2495.32L1045.2 2492.27C1045.59 2493.95 1045.55 2495.57 1045.07 2497.13C1044.59 2498.67 1043.69 2500.09 1042.37 2501.37C1041.06 2502.65 1039.36 2503.71 1037.26 2504.57Z",
    fill: "white"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.84 2469.95L1058.26 2475.87L1043.06 2482.1L1040.64 2476.18L1055.84 2469.95ZM1052.84 2497.71L1043.27 2474.34C1042.5 2472.47 1042.2 2470.78 1042.37 2469.27C1042.53 2467.77 1043.1 2466.46 1044.07 2465.34C1045.04 2464.23 1046.36 2463.34 1048.01 2462.66C1049.05 2462.23 1050.09 2461.9 1051.13 2461.66C1052.18 2461.41 1052.96 2461.25 1053.49 2461.18L1054.7 2467.52C1054.37 2467.55 1054 2467.62 1053.58 2467.73C1053.16 2467.84 1052.81 2467.95 1052.51 2468.07C1051.74 2468.38 1051.29 2468.76 1051.16 2469.19C1051.02 2469.63 1051.07 2470.11 1051.29 2470.64L1061 2494.36L1052.84 2497.71Z",
    fill: "white"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.65 2487.61C1076.23 2488.61 1073.95 2489 1071.82 2488.79C1069.69 2488.57 1067.79 2487.78 1066.13 2486.42C1064.48 2485.05 1063.15 2483.15 1062.15 2480.7C1061.18 2478.35 1060.82 2476.11 1061.04 2473.97C1061.27 2471.82 1062.05 2469.91 1063.37 2468.23C1064.7 2466.55 1066.53 2465.22 1068.88 2464.26C1070.6 2463.56 1072.26 2463.19 1073.87 2463.15C1075.47 2463.12 1076.98 2463.4 1078.38 2464.02C1079.78 2464.62 1081.04 2465.53 1082.16 2466.75C1083.28 2467.97 1084.21 2469.48 1084.95 2471.29L1085.73 2473.18L1065.44 2481.49L1063.6 2477L1076.37 2471.76C1076.1 2471.12 1075.7 2470.61 1075.17 2470.25C1074.65 2469.88 1074.06 2469.67 1073.4 2469.61C1072.75 2469.54 1072.09 2469.65 1071.41 2469.93C1070.75 2470.2 1070.2 2470.59 1069.77 2471.1C1069.33 2471.6 1069.04 2472.17 1068.91 2472.8C1068.78 2473.43 1068.85 2474.07 1069.1 2474.74L1071.09 2479.59C1071.38 2480.32 1071.8 2480.91 1072.34 2481.36C1072.88 2481.8 1073.51 2482.07 1074.21 2482.16C1074.92 2482.25 1075.67 2482.13 1076.48 2481.8C1077.04 2481.57 1077.52 2481.28 1077.92 2480.94C1078.33 2480.59 1078.64 2480.19 1078.86 2479.76C1079.07 2479.32 1079.16 2478.85 1079.15 2478.36L1086.6 2475.31C1086.99 2476.99 1086.95 2478.61 1086.47 2480.17C1085.98 2481.71 1085.08 2483.13 1083.77 2484.41C1082.46 2485.69 1080.75 2486.75 1078.65 2487.61Z",
    fill: "white"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.94 2481.28L1083.63 2458.57L1091.56 2455.32L1093.33 2459.64L1093.56 2459.54C1093.32 2457.77 1093.5 2456.34 1094.09 2455.23C1094.7 2454.12 1095.61 2453.31 1096.82 2452.82C1097.17 2452.67 1097.53 2452.56 1097.9 2452.48C1098.28 2452.38 1098.65 2452.31 1099.01 2452.28L1101.87 2459.24C1101.41 2459.27 1100.87 2459.37 1100.25 2459.55C1099.63 2459.72 1099.11 2459.89 1098.68 2460.07C1097.88 2460.39 1097.24 2460.87 1096.75 2461.5C1096.26 2462.11 1095.97 2462.82 1095.87 2463.62C1095.77 2464.41 1095.9 2465.24 1096.25 2466.11L1101.1 2477.93L1092.94 2481.28Z",
    fill: "white"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.99 2473.88L1101.69 2451.17L1109.61 2447.92L1111.38 2452.24L1111.62 2452.14C1111.38 2450.38 1111.55 2448.94 1112.15 2447.83C1112.75 2446.72 1113.66 2445.92 1114.87 2445.42C1115.23 2445.28 1115.59 2445.16 1115.96 2445.08C1116.33 2444.98 1116.7 2444.92 1117.07 2444.88L1119.92 2451.85C1119.46 2451.88 1118.92 2451.98 1118.3 2452.15C1117.68 2452.32 1117.16 2452.5 1116.74 2452.67C1115.94 2453 1115.29 2453.47 1114.8 2454.1C1114.32 2454.71 1114.03 2455.42 1113.93 2456.22C1113.82 2457.01 1113.95 2457.84 1114.31 2458.71L1119.15 2470.54L1110.99 2473.88Z",
    fill: "white"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.8 2462.97C1136.37 2463.97 1134.09 2464.36 1131.96 2464.15C1129.83 2463.93 1127.94 2463.14 1126.27 2461.78C1124.62 2460.41 1123.29 2458.5 1122.29 2456.06C1121.33 2453.71 1120.96 2451.47 1121.19 2449.33C1121.41 2447.18 1122.19 2445.27 1123.52 2443.59C1124.84 2441.91 1126.68 2440.58 1129.02 2439.62C1130.74 2438.92 1132.4 2438.55 1134.01 2438.51C1135.62 2438.48 1137.12 2438.76 1138.52 2439.37C1139.92 2439.98 1141.18 2440.89 1142.3 2442.11C1143.43 2443.33 1144.36 2444.84 1145.1 2446.65L1145.87 2448.54L1125.58 2456.85L1123.74 2452.36L1136.52 2447.12C1136.24 2446.47 1135.84 2445.97 1135.31 2445.61C1134.79 2445.24 1134.2 2445.02 1133.55 2444.97C1132.9 2444.9 1132.23 2445.01 1131.55 2445.29C1130.89 2445.56 1130.34 2445.95 1129.91 2446.46C1129.47 2446.96 1129.18 2447.53 1129.05 2448.16C1128.93 2448.79 1128.99 2449.43 1129.24 2450.1L1131.23 2454.95C1131.53 2455.68 1131.95 2456.27 1132.49 2456.72C1133.03 2457.16 1133.65 2457.43 1134.35 2457.52C1135.06 2457.61 1135.82 2457.49 1136.62 2457.16C1137.19 2456.93 1137.67 2456.64 1138.07 2456.3C1138.47 2455.94 1138.79 2455.55 1139 2455.12C1139.21 2454.68 1139.31 2454.21 1139.29 2453.72L1146.74 2450.67C1147.13 2452.35 1147.09 2453.97 1146.61 2455.52C1146.12 2457.07 1145.23 2458.49 1143.91 2459.77C1142.6 2461.05 1140.9 2462.11 1138.8 2462.97Z",
    fill: "white"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.42 2453.57C1159.81 2454.23 1158.14 2454.41 1156.44 2454.12C1154.74 2453.83 1153.13 2452.99 1151.6 2451.6C1150.09 2450.2 1148.79 2448.19 1147.72 2445.57C1146.59 2442.83 1146.1 2440.43 1146.25 2438.37C1146.4 2436.3 1146.99 2434.59 1148.02 2433.24C1149.05 2431.88 1150.32 2430.9 1151.81 2430.29C1152.94 2429.82 1154.01 2429.62 1155.01 2429.67C1156.02 2429.7 1156.94 2429.93 1157.78 2430.35C1158.61 2430.75 1159.34 2431.28 1159.95 2431.93L1160.07 2431.88L1155.34 2420.34L1163.5 2417L1175.91 2447.28L1167.81 2450.6L1166.28 2446.88L1166.1 2446.95C1166.1 2447.85 1165.93 2448.72 1165.59 2449.58C1165.26 2450.42 1164.74 2451.19 1164.05 2451.88C1163.36 2452.57 1162.49 2453.13 1161.42 2453.57ZM1161.87 2446.06C1162.62 2445.75 1163.17 2445.27 1163.53 2444.62C1163.89 2443.96 1164.05 2443.17 1164 2442.25C1163.97 2441.32 1163.72 2440.3 1163.27 2439.2C1162.81 2438.08 1162.27 2437.17 1161.65 2436.5C1161.03 2435.81 1160.36 2435.36 1159.65 2435.16C1158.94 2434.94 1158.21 2434.99 1157.46 2435.29C1156.71 2435.6 1156.16 2436.08 1155.8 2436.73C1155.45 2437.37 1155.3 2438.15 1155.35 2439.08C1155.4 2439.99 1155.66 2441.01 1156.12 2442.13C1156.58 2443.26 1157.11 2444.16 1157.72 2444.86C1158.33 2445.54 1158.99 2445.99 1159.69 2446.21C1160.39 2446.42 1161.12 2446.37 1161.87 2446.06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotF);
export default __webpack_public_path__ + "static/media/LotF.c3dc4331b452faf9c535c56417290bb8.svg";
export { ForwardRef as ReactComponent };